<template>
	<el-dialog
		:visible.sync="editformDialog"
		:before-close="handleClose"
		:title="`${storeObj.serial_no}. Edit Step Question`"
		:fullscreen="true"
		class="header"
	>
		<div v-loading="isloading" style="margin-left: 15px">
			<el-row :gutter="5">
				<el-col :span="7">
					<label>Input Type</label>
					<div>
						<!-- <select class="input-class-select mt-2" v-model="inputType">
									<option value="" disabled selected hidden>
										Select Input Type
									</option>
									<option
										v-for="item in inputTypeItems"
										:key="item.name"
										:label="item.name"
										:value="item.name"
									></option>
								</select> -->
						<el-select
							class="select mt-2"
							v-model="inputType"
							filterable
							placeholder="Select Input Type"
							clearable
							v-validate="'required'"
							name="Input Type"
						>
							<el-option
								v-for="(item, idx) in inputTypeItems"
								:key="idx"
								:value="item.name"
							>
								<el-row :gutter="3">
									<el-col :span="24">
										{{ item.name }}
									</el-col>
								</el-row>
							</el-option>
						</el-select>
						<p>
							<span
								:v-show="errors.has(`Input Type`)"
								class="text-red-dark text-xs"
							>
								{{ errors.first(`Input Type`) ? "This field is required" : "" }}
							</span>
						</p>
					</div>
				</el-col>
			</el-row>
			<el-row style="margin-top: 20px">
				<el-col :span="15">
					<label>Step Title</label>
					<div>
						<el-input
							type="text"
							v-model="title"
							placeholder="Enter step title"
							class="input-class mt-2"
							v-validate="'required'"
							name="Enter step title"
						/>
						<p>
							<span
								:v-show="errors.has(`Enter step title`)"
								class="text-red-dark text-xs"
							>
								{{
									errors.first(`Enter step title`)
										? "This field is required"
										: ""
								}}
							</span>
						</p>
					</div>
				</el-col>
			</el-row>
			<el-row v-if="inputType == 'Timer'" style="margin-top: 20px">
				<el-col :span="7">
					<label>Repeat Count</label>
					<div>
						<el-select
							id="ns-sec-input-01"
							class="select mt-2 ns-sec-input-type"
							v-model="timer_attempts"
							filterable
							placeholder="Select Repeat Count"
							clearable
							v-validate="'required'"
							name="SelectTimerAttempts"
						>
							<el-option
								v-for="(item, idx) in timer_attemptsItems"
								:key="idx"
								:value="item.name"
							>
								<el-row :gutter="3">
									<el-col :span="24">
										{{ item.name }}
									</el-col>
								</el-row>
							</el-option>
						</el-select>
						<p>
							<span
								:v-show="errors.has(`SelectTimerAttempts`)"
								class="text-red-dark text-xs"
							>
								{{
									errors.first(`SelectTimerAttempts`)
										? "This field is required"
										: ""
								}}
							</span>
						</p>
					</div>
				</el-col>
			</el-row>
			<div
				style="margin-top: 20px; display: flex"
				v-if="inputType == 'Temperature' || inputType == 'TPM'"
			>
				<div>Validation</div>
				<el-radio-group v-model="range">
					<el-radio style="margin-left: 20px; margin-top: 1px" :label="1"
						>Range</el-radio
					>
					<el-radio style="margin-left: 20px; margin-top: 1px" :label="2"
						>Less than or equal to</el-radio
					>
					<el-radio style="margin-left: 20px; margin-top: 1px" :label="3"
						>Greater than or equal to</el-radio
					>
					<el-radio style="margin-left: 20px; margin-top: 1px" :label="4"
						>Not Applicable</el-radio
					>
				</el-radio-group>
			</div>
			<el-row
				v-if="inputType == 'Temperature' && range != 4"
				style="margin-top: 20px"
			>
				<el-col v-if="range != 2" :span="7">
					<label>Minimum Value</label>
					<div>
						<el-input
							id="ns-sec-input-03"
							v-model="min_temp"
							placeholder="Enter Minimum Value"
							class="input-class mt-2"
							v-validate="'required'"
							name="Enter-Minimum-Value"
						/>
						<p>
							<span
								:v-show="errors.has(`Enter-Minimum-Value`)"
								class="text-red-dark text-xs"
							>
								{{
									errors.first(`Enter-Minimum-Value`)
										? "This field is required"
										: ""
								}}
							</span>
						</p>
					</div>
				</el-col>
				<el-col v-if="range != 3" :span="7" :offset="range != 2 ? 1 : 0">
					<label>Maximum Value</label>
					<div>
						<el-input
							id="ns-sec-input-04"
							v-model="max_temp"
							placeholder="Enter Maximum Value"
							class="input-class mt-2"
							v-validate="'required'"
							name="Enter-Maximum-Value"
							:min="min_temp"
							@input="validateMaxTEMP"
						/>
						<p>
							<span
								v-show="
									errors.items.some(
										(item) => item.field === 'Enter-Maximum-Value'
									)
								"
								class="text-red-dark text-xs"
							>
								{{
									errors.items.find(
										(item) => item.field === "Enter-Maximum-Value"
									)
										? errors.items.find(
												(item) => item.field === "Enter-Maximum-Value"
										  ).msg
										: ""
								}}
							</span>
						</p>
					</div>
				</el-col>
			</el-row>
			<el-row v-if="inputType == 'TPM'" style="margin-top: 20px">
				<el-col :span="7">
					<label>Minimum Value</label>
					<div>
						<el-input
							type="number"
							v-model="min_tpm"
							placeholder="Enter Minimum Value"
							class="input-class mt-2"
							v-validate="'required'"
							name="Enter Minimum Value"
						/>
						<p>
							<span
								:v-show="errors.has(`Enter Minimum Value`)"
								class="text-red-dark text-xs"
							>
								{{
									errors.first(`Enter Minimum Value`)
										? "This field is required"
										: ""
								}}
							</span>
						</p>
					</div>
				</el-col>
				<el-col :span="7" :offset="1">
					<label>Maximum Value</label>
					<div>
						<el-input
							type="number"
							v-model="max_tpm"
							placeholder="Enter Maximum Value"
							class="input-class mt-2"
							v-validate="'required'"
							name="Enter Maximum Value"
							@input="validateMaxTPM"
						/>
						<p>
							<span
								:v-show="errors.has(`Enter Maximum Value`)"
								class="text-red-dark text-xs"
							>
								{{
									errors.first(`Enter Maximum Value`)
										? "This field is required"
										: ""
								}}
							</span>
						</p>
					</div>
				</el-col>
			</el-row>
			<el-row
				v-if="
					inputType == 'Select any one' ||
					inputType == 'Multiselect' ||
					inputType == 'Dropdown'
				"
			>
				<el-col :span="15">
					<el-card
						style="border: 1px dashed; border-radius: 12px; margin-top: 20px"
						shadow="none"
					>
						<el-row :gutter="5">
							<el-col :span="8">
								<div><b>Option</b></div>
							</el-col>
							<el-col
								v-if="scoringType == 'Score for each step'"
								:span="8"
								:offset="1"
							>
								<div><b>Points</b></div>
							</el-col>
							<el-col
								:span="5"
								:offset="scoringType == 'Score for each step' ? 0 : 1"
							>
								<div><b>Condition</b></div>
							</el-col>
						</el-row>
						<el-row v-for="(item, idx) in radio_items" :key="idx" :gutter="5">
							<el-col :span="8">
								<el-input
									id="ns-sec-input-06"
									type="text"
									v-model="item.option_value"
									:placeholder="`${item.option}  ${idx + 1}`"
									class="input-class mt-2"
									v-validate="'required'"
									:name="`Enter-Minimum-Value-${idx + 1}`"
									:rules="idx < 2 ? 'required' : ''"
								/>
								<p
									v-for="(item, idx) in radio_items.slice(0, 2)"
									:key="'error-' + idx"
								>
									<span
										v-show="errors.has(`Enter-Minimum-Value-${idx + 1}`)"
										class="text-red-dark text-xs"
									>
										{{
											errors.first(`Enter-Minimum-Value-${idx + 1}`)
												? "This field is required"
												: ""
										}}
									</span>
								</p>
							</el-col>
							<el-col
								v-if="scoringType == 'Score for each step'"
								:span="8"
								:offset="1"
							>
								<el-select
									class="input-class mt-2"
									v-model="item.points_value"
									placeholder="Select Points"
								>
									<el-option
										v-for="(item, idx) in points_value_items"
										:key="idx"
										:label="item.title"
										:value="item.title"
									></el-option>
								</el-select>
							</el-col>
							<el-col
								:span="5"
								:offset="scoringType == 'Score for each step' ? 0 : 1"
							>
								<el-select
									class="input-class mt-2"
									v-model="item.condition_value"
								>
									<el-option
										v-for="item in yes_no_items"
										:key="item.title"
										:label="item.title"
										:value="item.title"
									></el-option>
								</el-select>
							</el-col>
							<el-col
								v-if="idx > 1"
								style="margin-top: 10px"
								:span="1"
								:offset="0"
							>
								<el-button
									@click="delete_row(idx, 0)"
									icon="el-icon-delete"
									style="border: none"
									plain
								></el-button>
							</el-col>
						</el-row>
						<el-row style="margin-top: 20px; margin-left: -40px">
							<el-col :span="4">
								<el-button
									@click="add_radio_items(0)"
									class="button-class-white-dialog"
									icon="el-icon-plus"
								>
									Add More
								</el-button>
							</el-col>
						</el-row>
					</el-card>
				</el-col>
			</el-row>
			<el-row v-if="inputType == 'Rating'" style="margin-top: 20px">
				<el-col :span="4">
					<label>Number Interval</label>
					<div>
						<el-select
							v-model="number_interval"
							placeholder="Select Interval"
							class="select mt-2"
							v-validate="'required'"
							name="Select Interval"
						>
							<el-option
								v-for="(item, idx) in number_interval_items"
								:key="idx"
								:label="item.title"
								:value="item.title"
							></el-option>
						</el-select>
						<p>
							<span
								:v-show="errors.has(`Enter Interval`)"
								class="text-red-dark text-xs"
							>
								{{
									errors.first(`Enter Interval`) ? "This field is required" : ""
								}}
							</span>
						</p>
					</div>
				</el-col>
				<el-col :span="4" :offset="1">
					<label>Minimum Value</label>
					<div>
						<el-select
							class="select mt-2"
							v-model="minimum_value"
							:disabled="!number_interval"
							v-validate="'required'"
							name="Select Minimum Value"
						>
							<el-option
								v-for="(item, idx) in minimum_maximum_value_items"
								:key="idx"
								:label="item.title"
								:value="item.title"
							></el-option>
						</el-select>
						<p>
							<span
								:v-show="errors.has(`Enter Minimum Value`)"
								class="text-red-dark text-xs"
							>
								{{
									errors.first(`Enter Minimum Value`)
										? "This field is required"
										: ""
								}}
							</span>
						</p>
					</div>
				</el-col>
				<el-col :span="4" :offset="1">
					<label>Maximum Value</label>
					<div>
						<el-select
							class="select mt-2"
							v-model="maximum_value"
							:disabled="!number_interval"
							v-validate="'required'"
							name="Select Maximum Value"
						>
							<el-option
								v-for="(item, idx) in minimum_maximum_value_items"
								:key="idx"
								:label="item.title"
								:value="item.title"
							></el-option>
						</el-select>
						<p>
							<span
								:v-show="errors.has(`Enter Maximum Value`)"
								class="text-red-dark text-xs"
							>
								{{
									errors.first(`Enter Maximum Value`)
										? "This field is required"
										: ""
								}}
							</span>
						</p>
					</div>
				</el-col>
			</el-row>
			<el-row style="margin-top: 20px">
				<el-col :span="15">
					<label>Add description</label>
					<div>
						<vue-editor
							v-model="description"
							style="width: 100%; margin-top: 10px"
							:editorToolbar="customToolbar"
						></vue-editor>
					</div>
				</el-col>
			</el-row>
			<el-row style="margin-top: 30px">
				<el-col :span="12">
					<el-button
						class="button-class-white"
						icon="el-icon-upload"
						@click="$refs.fileUploadSelector.click()"
					>
						Upload File
					</el-button>
					No file Chosen
					<div style="font-size: 12px; margin-top: 5px">
						only JPG, JPEG, PNG, GIF and PDF formats with max file size of 5 mb
						maximum allowed (5 files)
					</div>
					<input
						type="file"
						ref="fileUploadSelector"
						id="fileInput"
						accept=".jpeg, .jpg, .png, .pdf, .gif, .csv, .webp, .vnd.openxmlformats-officedocument.spreadsheetml.sheet, .vnd.ms-excel, .mp4, .mov, .wmv, .avi, .avchd, .flv, .f4v, .swf, .mkv, .webm, .mpg, .mp2, .mpeg, .mpe, .mpv"
						multiple
						@change="upload_file_handler"
						style="display: none"
					/>
					<!-- <canvas id="pdfViewer"></canvas> -->
				</el-col>
			</el-row>
			<el-row style="margin-top: 10px" v-if="fileURLArray">
				<el-col
					style="margin-right: 20px"
					v-for="(item, idx) in fileURLArray"
					:key="idx"
					:span="1"
				>
					<div style="cursor: pointer">
						<el-tooltip
							class="item"
							v-if="
								item.fileDetails.type.includes('image') ||
								item.fileDetails.type.includes('jpg') ||
								item.fileDetails.type.includes('jpeg') ||
								item.fileDetails.type.includes('png') ||
								item.fileDetails.type.includes('gif') ||
								item.fileDetails.type.includes('bmp') ||
								item.fileDetails.type.includes('webp')
							"
							effect="light"
							content="Click to show image"
							placement="bottom"
						>
							<img
								:src="item.src"
								@click="show_excel(item.src)"
								style="height: 50px"
							/>
						</el-tooltip>
						<el-tooltip
							class="item"
							v-if="
								item.fileDetails.type.includes('mp4') ||
								item.fileDetails.type.includes('mov') ||
								item.fileDetails.type.includes('wmv') ||
								item.fileDetails.type.includes('avi') ||
								item.fileDetails.type.includes('avchd') ||
								item.fileDetails.type.includes('flv') ||
								item.fileDetails.type.includes('f4v') ||
								item.fileDetails.type.includes('swf') ||
								item.fileDetails.type.includes('mkv') ||
								item.fileDetails.type.includes('webm') ||
								item.fileDetails.type.includes('mpg') ||
								item.fileDetails.type.includes('mp2') ||
								item.fileDetails.type.includes('mpeg') ||
								item.fileDetails.type.includes('mpe') ||
								item.fileDetails.type.includes('mpv') ||
								item.fileDetails.type.includes('video')
							"
							effect="light"
							content="Click to show image"
							placement="bottom"
						>
							<video
								:src="item.src"
								@click="show_excel(item.src)"
								style="height: 50px"
							/>
						</el-tooltip>
						<el-tooltip
							v-if="item.fileDetails.type.includes('pdf')"
							class="item"
							effect="light"
							content="Click to show pdf"
							placement="bottom"
						>
							<img
								style="height: 50px"
								@click="show_excel(item.src)"
								src="../../../assets/icons/pdf.png"
							/>
						</el-tooltip>
						<el-tooltip
							v-if="
								item.fileDetails.type.includes('csv') ||
								item.fileDetails.type.includes('sheet')
							"
							class="item"
							effect="light"
							content="Click to show excel"
							placement="bottom"
						>
							<img
								style="height: 50px"
								@click="show_excel(item.src)"
								src="../../../assets/icons/excel.png"
							/>
						</el-tooltip>
						<div class="text-right">
							<i @click="delete_file_list(item)" class="el-icon-delete" />
						</div>
					</div>
				</el-col>
			</el-row>
			<!-- <div id="fileList"></div> -->
			<el-row style="margin-top: 20px">
				<el-col :span="15">
					<el-card
						style="border: 1px solid; border-color: #d3d3d3"
						shadow="none"
					>
						<el-row :gutter="5">
							<el-col :span="5">
								<div>Mandatory Field</div>
							</el-col>
							<el-col :span="6">
								<el-switch
									id="ns-sec-switch-01"
									v-model="mandatoryField"
									:active-text="mandatoryField ? '(Yes)' : '(No)'"
									active-color="#41BE62"
								>
								</el-switch>
							</el-col>
							<el-col :span="5" :offset="2">
								<div>Allow NA (Not Applicable)</div>
							</el-col>
							<el-col :span="6">
								<el-switch
									id="ns-sec-switch-02"
									v-model="notApplicable"
									:active-text="notApplicable ? '(Yes)' : '(No)'"
									active-color="#41BE62"
								>
								</el-switch>
							</el-col>
						</el-row>
						<el-row style="margin-top: 20px" :gutter="5">
							<el-col :span="5">
								<div>Image Required</div>
							</el-col>
							<el-col :span="6">
								<el-switch
									id="ns-sec-switch-03"
									v-model="imageRequired"
									:active-text="imageRequired ? '(Yes)' : '(No)'"
									active-color="#41BE62"
								>
								</el-switch>
							</el-col>
							<!-- <el-col :span="5" :offset="2">
									<div>Raise Ticket</div>
								</el-col>
								<el-col :span="6">
									<el-switch
										v-model="raiseTicket"
										:active-text="raiseTicket ? '(Allowed)' : '(optional)'"
										active-color="#41BE62"
									>
									</el-switch>
								</el-col> -->
							<el-col :span="5" :offset="2">
								<div>Comment Required</div>
							</el-col>
							<el-col :span="6">
								<el-switch
									id="ns-sec-switch-04"
									v-model="commentRequired"
									:active-text="commentRequired ? '(Yes)' : '(No)'"
									active-color="#41BE62"
								>
								</el-switch>
							</el-col>
						</el-row>
						<el-row style="margin-top: 20px" :gutter="5">
							<el-col :span="5">
								<div>Upload from Gallery</div>
							</el-col>
							<el-col :span="6">
								<el-switch
									id="ns-sec-switch-03"
									v-model="UploadFromGalleryRequired"
									:active-text="UploadFromGalleryRequired ? '(Yes)' : '(No)'"
									active-color="#41BE62"
								>
								</el-switch>
							</el-col>
						</el-row>
						<!-- <el-row style="margin-top: 20px" :gutter="5">
								
							</el-row> -->
					</el-card>
				</el-col>
			</el-row>
			<!-- <el-row style="margin-top: 20px">
				<el-col :span="15">
					<el-card
						style="border: 1px solid; border-color: #d3d3d3"
						shadow="none"
					>
						<el-row :gutter="5">
							<el-col :span="5">
								<div>Action</div>
							</el-col>
							<el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6">
								<el-radio v-model="raiseTicket" label="1">Applicable</el-radio>
							</el-col>
							<el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6">
								<el-radio v-model="raiseTicket" label="2"
									>Not Applicable</el-radio
								>
							</el-col>
						</el-row>
						<el-row
							v-if="raiseTicket == '1'"
							style="margin-top: 20px"
							:gutter="5"
						>
							<el-col :span="23">
								<div>
									Enables a user to generate a subsequent action for reporting
									an issue, highlight observation or areas of improvement
								</div>
							</el-col>
						</el-row>
						<el-row
							style="margin-top: 20px"
							v-if="raiseTicket == '1'"
							:gutter="5"
						>
							<el-col :span="5">
								<div>Assign To</div>
							</el-col>
							<el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8">
								<el-select
									class="select"
									v-model="designation"
									filterable
									placeholder="Select Designation"
									:multiple="true"
									v-validate="'required'"
									name="Select Designation"
									collapse-tags
								>
									<el-option
										v-for="(item, key) in designationItems"
										:key="key"
										:label="item.name"
										:value="item.id"
									>
									</el-option>
								</el-select>
								<p>
									<span
										:v-show="errors.has(`Select Designation`)"
										class="text-red-dark text-xs"
									>
										{{
											errors.first(`Select Designation`)
												? "This field is required"
												: ""
										}}
									</span>
								</p>
							</el-col>
						</el-row>
					</el-card>
				</el-col>
			</el-row> -->
			<el-row
				v-if="
					(inputType == 'Yes / No' ||
						inputType == 'Temperature' ||
						inputType == 'TPM') &&
					scoringType != 'Not Applicable'
				"
				style="margin-top: 40px; font-size: 12px"
			>
				<el-col :span="3">
					<div style="font-size: 14px">Expected Response</div>
				</el-col>
				<el-col
					:style="
						inputType == 'Yes / No' ? 'margin-left: 20px' : 'margin-left:-25px'
					"
					:span="inputType == 'Yes / No' ? 1 : 2"
				>
					<span :style="inputType == 'Yes / No' ? '' : 'font-size:11px'"
						><b>{{ inputType == "Yes / No" ? "Yes" : "In Range" }}</b></span
					>
				</el-col>
				<el-col
					style="margin-top: -25px"
					:style="
						inputType == 'Yes / No'
							? 'margin-left: -20px'
							: 'margin-left: -70px'
					"
					:span="5"
				>
					<el-card
						style="
							border: 1px solid;
							border-color: #f9a168;
							height: 60px;
							margin-top: 20px;
						"
					>
						<el-row style="margin-left: -10px; margin-right: -10px" :gutter="0">
							<el-col style="margin-top: -5px" :span="8">
								<el-select
									id="ns-sel-input-01"
									class="select1"
									v-model="yes_value"
									filterable
									placeholder="Select Input Type"
								>
									<el-option
										v-for="(item, idx) in yes_no_items"
										:key="idx"
										:label="item.title"
										:value="item.value"
									>
									</el-option>
								</el-select>
							</el-col>
							<el-col
								v-if="scoringType == 'Score for each step'"
								style="margin-top: 0px"
								:span="4"
								:offset="1"
							>
								<span style="margin-left: 5px">Points</span>
							</el-col>
							<el-col
								v-if="scoringType == 'Score for each step'"
								style="margin-top: -5px"
								:span="11"
							>
								<el-select
									id="ns-sel-input-02"
									class="select1"
									v-model="yes_value_select_points"
									filterable
									placeholder="Select Points"
									v-validate="
										scoringType == 'Score for each step' ? 'required' : ''
									"
									name="Select Points"
								>
									<el-option
										v-for="(item, idx) in points_value_items"
										:key="idx"
										:label="item.title"
										:value="item.value"
									>
									</el-option>
								</el-select>
								<p>
									<span
										:v-show="errors.has(`Select Points`)"
										class="text-red-dark text-xs"
									>
										{{
											errors.first(`Select Points`)
												? "This field is required"
												: ""
										}}
									</span>
								</p>
							</el-col>
						</el-row>
						<span> </span>
					</el-card>
				</el-col>
				<el-col :span="inputType == 'Yes / No' ? 1 : 2" :offset="0">
					<span
						:style="
							inputType == 'Yes / No'
								? 'margin-left: 30px'
								: 'font-size:11px; margin-left:15px'
						"
						style=""
						><b>{{ inputType == "Yes / No" ? "No" : "Outside Range" }}</b></span
					>
				</el-col>
				<el-col
					style="margin-top: -25px"
					:style="inputType == 'Yes / No' ? '' : 'margin-left:-25px'"
					:span="5"
				>
					<el-card
						style="
							border: 1px solid;
							border-color: #f9a168;
							height: 60px;
							margin-top: 20px;
						"
					>
						<el-row style="margin-left: -10px; margin-right: -10px" :gutter="0">
							<el-col style="margin-top: -5px" :span="8">
								<el-select
									id="ns-sel-input-03"
									class="select1"
									v-model="no_value"
									filterable
									placeholder="Select Input Type"
								>
									<el-option
										v-for="(item, idx) in yes_no_items"
										:key="idx"
										:label="item.title"
										:value="item.value"
									>
									</el-option>
								</el-select>
							</el-col>
							<el-col
								v-if="scoringType == 'Score for each step'"
								style="margin-top: 0px"
								:span="4"
								:offset="1"
							>
								<span style="margin-left: 5px">Points</span>
							</el-col>
							<el-col
								v-if="scoringType == 'Score for each step'"
								style="margin-top: -5px"
								:span="11"
							>
								<el-select
									id="ns-sel-input-04"
									class="select1"
									v-model="no_value_select_points"
									filterable
									placeholder="Select Points"
									v-validate="
										scoringType == 'Score for each step' ? 'required' : ''
									"
									name="Select Points"
								>
									<el-option
										v-for="(item, idx) in points_value_items"
										:key="idx"
										:label="item.title"
										:value="item.value"
									>
									</el-option>
								</el-select>
								<p>
									<span
										:v-show="errors.has(`Select Points`)"
										class="text-red-dark text-xs"
									>
										{{
											errors.first(`Select Points`)
												? "This field is required"
												: ""
										}}
									</span>
								</p>
							</el-col>
						</el-row>
					</el-card>
				</el-col>
			</el-row>
			<el-row
				v-if="
					inputType == 'Yes / No' ||
					inputType == 'Temperature' ||
					inputType == 'TPM' ||
					inputType == 'Select any one' ||
					inputType == 'Rating' ||
					inputType == 'Multiselect' ||
					inputType == 'Dropdown'
				"
				style="margin-top: 30px"
			>
				<el-col :span="4">
					<div>Critical step</div>
				</el-col>
				<el-col :span="2">
					<el-switch
						v-model="criticalStep"
						:active-text="criticalStep ? '(Yes)' : '(No)'"
						active-color="#41BE62"
					>
					</el-switch>
				</el-col>
				<el-col :span="16">
					<div
						style="
							font-size: 10px;
							margin-top: 5px;
							margin-left: 10px;
							color: #ff0000;
						"
					>
						If enabled, total points for the form will be marked as zero if
						expected response for this step is Fail
					</div>
				</el-col>
			</el-row>
			<el-row v-if="criticalStep" style="margin-top: 30px">
				<el-col :span="4">
					<div>Select any one</div>
				</el-col>
				<el-col :span="5">
					<el-select
						class="select"
						v-model="critical_option"
						filterable
						placeholder="Select"
						v-validate="'required'"
						name="Select Critical"
						collapse-tags
					>
						<el-option
							v-for="(item, key) in critical_options"
							:key="key"
							:label="item.name"
							:value="item.id"
						>
						</el-option>
					</el-select>
					<p>
						<span
							:v-show="errors.has(`Select Critical`)"
							class="text-red-dark text-xs"
						>
							{{
								errors.first(`Select Critical`) ? "This field is required" : ""
							}}
						</span>
					</p>
				</el-col>
			</el-row>
			<el-row
				style="margin-top: 30px"
				v-if="
					inputType == 'Yes / No' ||
					inputType == 'Temperature' ||
					inputType == 'TPM' ||
					inputType == 'Select any one' ||
					inputType == 'Rating' ||
					inputType == 'Multiselect' ||
					inputType == 'Dropdown'
				"
			>
				<el-col :span="4">
					<div>Dependent Question</div>
				</el-col>
				<el-col :span="2">
					<el-switch
						v-model="dependentQuestions"
						:active-text="dependentQuestions ? '(Yes)' : '(No)'"
						active-color="#41BE62"
					>
					</el-switch>
				</el-col>
			</el-row>
			<el-row
				style="margin-top: 30px"
				v-if="
					(inputType == 'Yes / No' ||
						inputType == 'Temperature' ||
						inputType == 'TPM' ||
						inputType == 'Select any one' ||
						inputType == 'Multiselect' ||
						inputType == 'Dropdown') &&
					dependentQuestions
				"
			>
				<el-col :span="4">
					<div>Display</div>
				</el-col>
				<el-col :span="5">
					<el-radio v-model="radio" label="1" text-color="#000000">
						Always
					</el-radio>
					<el-radio v-model="radio" label="2" text-color="#000000">
						When Expected Answer
					</el-radio>
				</el-col>
				<el-col style="margin-top: -5px" :span="3">
					<select
						class="input-class-select-yes_no ml-3"
						v-model="exp_yes_value"
					>
						<option
							v-for="item in yes_no_items"
							:key="item.title"
							:label="item.title"
							:value="item.value"
						></option>
					</select>
				</el-col>
			</el-row>
			<el-row
				v-if="inputType == 'Rating' && dependentQuestions"
				style="margin-top: 30px"
			>
				<el-col :span="2">
					<div>Display</div>
				</el-col>
				<el-col :span="2">
					<el-radio v-model="radio" label="1" text-color="#000000">
						Always
					</el-radio>
				</el-col>
				<el-col :span="4">
					<el-radio v-model="radio" label="2" text-color="#000000">
						When Expected Answer Is Below
					</el-radio>
				</el-col>
				<el-col style="margin-top: -10px" :span="2">
					<el-select class="select" v-model="exp_below_value">
						<el-option
							v-for="(item, idx) in minimum_maximum_value_items_rating"
							:key="idx"
							:label="item.title"
							:value="item.title"
						></el-option>
					</el-select>
				</el-col>
				<el-col :span="4" :offset="1">
					<el-radio v-model="radio" label="3" text-color="#000000">
						When Expected Answer Is Above
					</el-radio>
				</el-col>
				<el-col style="margin-top: -10px" :span="2">
					<el-select class="select" v-model="exp_above_value">
						<el-option
							v-for="(item, idx) in minimum_maximum_value_items_rating"
							:key="idx"
							:label="item.title"
							:value="item.title"
						></el-option>
					</el-select>
				</el-col>
			</el-row>
			<div style="margin-top: 20px" v-if="dependentQuestions">
				<el-row>
					<el-col :span="24">
						<div
							style="border: 1px solid; border-color: #d3d3d3"
							class="my-5"
						></div>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="24">
						<h2>Dependent Question</h2>
					</el-col>
				</el-row>
				<el-row>
					<el-col style="margin-top: 30px" :span="7">
						<label>Input Type</label>
						<div>
							<el-select
								class="select mt-2"
								v-model="dependent_inputType"
								filterable
								placeholder="Select Input Type"
								clearable
								v-validate="'required'"
								name="Select Dependent Input Type"
							>
								<el-option
									v-for="(item, idx) in inputTypeItems"
									:key="idx"
									:value="item.name"
								>
									<el-row :gutter="3">
										<el-col :span="24">
											{{ item.name }}
										</el-col>
									</el-row>
								</el-option>
							</el-select>
							<p>
								<span
									:v-show="errors.has(`Select Dependent Input Type`)"
									class="text-red-dark text-xs"
								>
									{{
										errors.first(`Select Dependent Input Type`)
											? "This field is required"
											: ""
									}}
								</span>
							</p>
						</div>
					</el-col>
				</el-row>
			</div>

			<el-row
				style="margin-top: 30px"
				v-if="dependent_inputType && dependentQuestions"
			>
				<el-col :span="16">
					<div
						style="
							border: 2px dashed;
							border-color: #f9a168;
							margin-bottom: 30px;
							border-radius: 12px;
						"
					>
						<el-card>
							<el-row style="margin-top: 20px">
								<el-col :span="23">
									<label>Step Title</label>
									<div>
										<el-input
											type="text"
											v-model="dependent_title"
											placeholder="Enter step title"
											class="input-class mt-2"
											v-validate="'required'"
											name="Step Title"
										/>
										<p>
											<span
												:v-show="errors.has(`Step Title`)"
												class="text-red-dark text-xs"
											>
												{{
													errors.first(`Step Title`)
														? "This field is required"
														: ""
												}}
											</span>
										</p>
									</div>
								</el-col>
							</el-row>
							<el-row
								v-if="dependent_inputType == 'Temperature'"
								style="margin-top: 20px"
							>
								<el-col :span="11">
									<label>Minimum Value</label>
									<div>
										<el-input
											type="number"
											v-model="dependent_min_temp"
											placeholder="Enter Minimum Value"
											class="input-class mt-2"
											v-validate="'required'"
											name="Dependent Minimum Value"
										/>
										<p>
											<span
												:v-show="errors.has(`Dependent Minimum Value`)"
												class="text-red-dark text-xs"
											>
												{{
													errors.first(`Dependent Minimum Value`)
														? "This field is required"
														: ""
												}}
											</span>
										</p>
									</div>
								</el-col>
								<el-col :span="11" :offset="1">
									<label>Maximum Value</label>
									<div>
										<el-input
											type="number"
											v-model="dependent_max_temp"
											placeholder="Enter Maximum Value"
											class="input-class mt-2"
											v-validate="'required'"
											name="Dependent Maximum Value"
										/>
										<p>
											<span
												:v-show="errors.has(`Dependent Maximum Value`)"
												class="text-red-dark text-xs"
											>
												{{
													errors.first(`Dependent Maximum Value`)
														? "This field is required"
														: ""
												}}
											</span>
										</p>
									</div>
								</el-col>
							</el-row>
							<el-row
								v-if="dependent_inputType == 'TPM'"
								style="margin-top: 20px"
							>
								<el-col :span="11">
									<label>Minimum Value</label>
									<div>
										<el-input
											type="number"
											v-model="dependent_min_tpm"
											placeholder="Enter Minimum Value"
											class="input-class mt-2"
											v-validate="'required'"
											name="Dependent Minimum Value"
										/>
										<p>
											<span
												:v-show="errors.has(`Dependent Maximum Value`)"
												class="text-red-dark text-xs"
											>
												{{
													errors.first(`Dependent Maximum Value`)
														? "This field is required"
														: ""
												}}
											</span>
										</p>
									</div>
								</el-col>
								<el-col :span="11" :offset="1">
									<label>Maximum Value</label>
									<div>
										<el-input
											type="number"
											v-model="dependent_max_tpm"
											placeholder="Enter Maximum Value"
											class="input-class mt-2"
											v-validate="'required'"
											name="Dependent Maximum Value"
										/>
										<p>
											<span
												:v-show="errors.has(`Dependent Maximum Value`)"
												class="text-red-dark text-xs"
											>
												{{
													errors.first(`Dependent Maximum Value`)
														? "This field is required"
														: ""
												}}
											</span>
										</p>
									</div>
								</el-col>
							</el-row>
							<el-row
								v-if="
									dependent_inputType == 'Select any one' ||
									dependent_inputType == 'Multiselect' ||
									dependent_inputType == 'Dropdown'
								"
							>
								<el-col :span="23">
									<el-card
										shadow="none"
										style="
											border: 1px dashed;
											border-radius: 12px;
											margin-top: 20px;
										"
									>
										<el-row :gutter="5">
											<el-col :span="8">
												<div><b>Option</b></div>
											</el-col>
											<el-col
												:span="8"
												v-if="scoringType == 'Score for each step'"
											>
												<div><b>Points</b></div>
											</el-col>
											<el-col :span="8" :offset="0">
												<div><b>Condition</b></div>
											</el-col>
										</el-row>
										<el-row
											v-for="(item, idx) in dependent_radio_items"
											:key="idx"
											:gutter="5"
										>
											<el-col :span="7">
												<el-input
													type="text"
													v-model="item.option_value"
													:placeholder="`${item.option}  ${idx + 1}`"
													class="input-class mt-2"
												/>
											</el-col>
											<el-col
												:span="7"
												:offset="1"
												v-if="scoringType == 'Score for each step'"
											>
												<el-select
													class="select mt-2"
													v-model="item.points_value"
												>
													<el-option
														v-for="(item, idx) in points_value_items"
														:key="idx"
														:label="item.title"
														:value="item.title"
													></el-option>
												</el-select>
											</el-col>
											<el-col :span="5" :offset="1">
												<el-select
													class="select mt-2"
													v-model="item.condition_value"
												>
													<el-option
														v-for="(item, idx) in yes_no_items"
														:key="idx"
														:label="item.title"
														:value="item.title"
													></el-option>
												</el-select>
											</el-col>
											<el-col
												v-if="idx > 1"
												style="margin-top: 10px"
												:span="1"
												:offset="0"
											>
												<el-button
													@click="delete_row(idx, 1)"
													icon="el-icon-delete"
													style="border: none"
													plain
												></el-button>
											</el-col>
										</el-row>
										<el-row style="margin-top: 20px; margin-left: -40px">
											<el-col :span="4">
												<el-button
													@click="add_radio_items(1)"
													class="button-class-white-dialog"
													icon="el-icon-plus"
												>
													Add More
												</el-button>
											</el-col>
										</el-row>
									</el-card>
								</el-col>
							</el-row>
							<el-row
								v-if="dependent_inputType == 'Rating'"
								style="margin-top: 20px"
							>
								<el-col :span="7">
									<label>Number Interval</label>
									<div>
										<el-select
											class="select mt-2"
											v-model="dependent_number_interval"
											v-validate="'required'"
											name="Dependent Number Interval"
										>
											<el-option
												v-for="(item, idx) in number_interval_items"
												:key="idx"
												:label="item.title"
												:value="item.title"
											></el-option>
										</el-select>
										<p>
											<span
												:v-show="errors.has(`Dependent Number Interval`)"
												class="text-red-dark text-xs"
											>
												{{
													errors.first(`Dependent Number Interval`)
														? "This field is required"
														: ""
												}}
											</span>
										</p>
									</div>
								</el-col>
								<el-col :span="7" :offset="1">
									<label>Minimum Value</label>
									<div>
										<el-select
											class="select mt-2"
											v-model="dependent_minimum_value"
											:disabled="!dependent_number_interval"
											v-validate="'required'"
											name="Dependent Minimum Value"
										>
											<el-option
												v-for="(
													item, idx
												) in dependent_minimum_maximum_value_items"
												:key="idx"
												:label="item.title"
												:value="item.title"
											></el-option>
										</el-select>
										<p>
											<span
												:v-show="errors.has(`Dependent Maximum Value`)"
												class="text-red-dark text-xs"
											>
												{{
													errors.first(`Dependent Maximum Value`)
														? "This field is required"
														: ""
												}}
											</span>
										</p>
									</div>
								</el-col>
								<el-col :span="7" :offset="1">
									<label>Maximum Value</label>
									<div>
										<el-select
											class="select mt-2"
											v-model="dependent_maximum_value"
											:disabled="!dependent_number_interval"
											v-validate="'required'"
											name="Dependent Maximum Value"
										>
											<el-option
												v-for="(
													item, idx
												) in dependent_minimum_maximum_value_items"
												:key="idx"
												:label="item.title"
												:value="item.title"
											></el-option>
										</el-select>
										<p>
											<span
												:v-show="errors.has(`Dependent Maximum Value`)"
												class="text-red-dark text-xs"
											>
												{{
													errors.first(`Dependent Maximum Value`)
														? "This field is required"
														: ""
												}}
											</span>
										</p>
									</div>
								</el-col>
							</el-row>
							<el-row style="margin-top: 20px">
								<el-col :span="23">
									<el-card
										style="border: 1px solid; border-color: #d3d3d3"
										shadow="none"
									>
										<el-row :gutter="5">
											<el-col :span="5">
												<div>Mandatory Field</div>
											</el-col>
											<el-col :span="6">
												<el-switch
													v-model="dependent_mandatoryField"
													:active-text="
														mandatoryField ? '(Allowed)' : '(optional)'
													"
													active-color="#41BE62"
												>
												</el-switch>
											</el-col>
											<el-col :span="5" :offset="2">
												<div>Not Applicable</div>
											</el-col>
											<el-col :span="6">
												<el-switch
													v-model="dependent_notApplicable"
													:active-text="
														notApplicable ? '(Allowed)' : '(optional)'
													"
													active-color="#41BE62"
												>
												</el-switch>
											</el-col>
										</el-row>
										<el-row style="margin-top: 20px" :gutter="5">
											<el-col :span="5">
												<div>Image Required</div>
											</el-col>
											<el-col :span="6">
												<el-switch
													v-model="dependent_imageRequired"
													:active-text="
														imageRequired ? '(Allowed)' : '(optional)'
													"
													active-color="#41BE62"
												>
												</el-switch>
											</el-col>
											<!-- <el-col :span="5" :offset="2">
													<div>Raise Ticket</div>
												</el-col>
												<el-col :span="6">
													<el-switch
														v-model="dependent_raiseTicket"
														:active-text="
															raiseTicket ? '(Allowed)' : '(optional)'
														"
														active-color="#41BE62"
													>
													</el-switch>
												</el-col> -->
											<el-col :span="5" :offset="2">
												<div>Comment Required</div>
											</el-col>
											<el-col :span="6">
												<el-switch
													v-model="dependent_commentRequired"
													:active-text="
														commentRequired ? '(Allowed)' : '(optional)'
													"
													active-color="#41BE62"
												>
												</el-switch>
											</el-col>
										</el-row>
										<!-- <el-row style="margin-top: 20px" :gutter="5">

											</el-row> -->
									</el-card>
								</el-col>
							</el-row>
							<!-- <el-row style="margin-top: 20px">
								<el-col :span="23">
									<el-card
										style="border: 1px solid; border-color: #d3d3d3"
										shadow="none"
									>
										<el-row :gutter="5">
											<el-col :span="5">
												<div>Action</div>
											</el-col>
											<el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6">
												<el-radio v-model="dependent_raiseTicket" label="1"
													>Applicable</el-radio
												>
											</el-col>
											<el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6">
												<el-radio v-model="dependent_raiseTicket" label="2"
													>Not Applicable</el-radio
												>
											</el-col>
										</el-row>
										<el-row
											v-if="dependent_raiseTicket == '1'"
											style="margin-top: 20px"
											:gutter="5"
										>
											<el-col :span="23">
												<div>
													Enables a user to generate a subsequent action for
													reporting an issue, highlight observation or areas of
													improvement
												</div>
											</el-col>
										</el-row>
										<el-row
											style="margin-top: 20px"
											v-if="dependent_raiseTicket == '1'"
											:gutter="5"
										>
											<el-col :span="5">
												<div>Assign To</div>
											</el-col>
											<el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8">
												<el-select
													class="select"
													v-model="dependent_designation"
													filterable
													placeholder="Select Designation"
													:multiple="true"
													v-validate="'required'"
													name="Select Designation"
													collapse-tags
												>
													<el-option
														v-for="(item, key) in designationItems"
														:key="key"
														:label="item.name"
														:value="item.id"
													>
													</el-option>
												</el-select>
												<p>
													<span
														:v-show="errors.has(`Select Designation`)"
														class="text-red-dark text-xs"
													>
														{{
															errors.first(`Select Designation`)
																? "This field is required"
																: ""
														}}
													</span>
												</p>
											</el-col>
										</el-row>
									</el-card>
								</el-col>
							</el-row> -->
							<el-row
								v-if="
									dependent_inputType == 'Yes / No' ||
									dependent_inputType == 'Temperature' ||
									dependent_inputType == 'TPM'
								"
								style="margin-top: 40px; font-size: 12px"
							>
								<el-col :span="4">
									<div style="font-size: 14px">Expected Response</div>
								</el-col>
								<el-col
									:style="
										dependent_inputType == 'Yes / No'
											? 'margin-left: 20px'
											: 'margin-left: 15px'
									"
									:span="dependent_inputType == 'Yes / No' ? 1 : 2"
								>
									<span
										:style="
											dependent_inputType == 'Yes / No' ? '' : 'font-size:13px'
										"
										><b>{{
											dependent_inputType == "Yes / No" ? "Yes" : "In Range"
										}}</b></span
									>
								</el-col>
								<el-col
									style="margin-top: -25px"
									:style="
										dependent_inputType == 'Yes / No'
											? 'margin-left: 0px'
											: 'margin-left: -18'
									"
									:span="dependent_inputType == 'Yes / No' ? 8 : 7"
								>
									<el-card
										style="
											border: 1px solid;
											border-color: #f9a168;
											height: 60px;
											margin-top: 20px;
										"
									>
										<el-row
											style="margin-left: -10px; margin-right: -10px"
											:gutter="0"
										>
											<el-col style="margin-top: -5px" :span="8">
												<el-select
													class="select1"
													v-model="dependent_yes_value"
													filterable
													placeholder="Select Input Type"
													clearable
												>
													<el-option
														v-for="(item, idx) in yes_no_items"
														:key="idx"
														:label="item.title"
														:value="item.value"
													>
													</el-option>
												</el-select>
											</el-col>
											<el-col
												v-if="scoringType == 'Score for each step'"
												style="margin-top: 0px"
												:span="4"
												:offset="1"
											>
												<span style="margin-left: 5px">Points</span>
											</el-col>
											<el-col
												v-if="scoringType == 'Score for each step'"
												style="margin-top: -5px"
												:span="11"
											>
												<el-select
													class="select1"
													v-model="dependent_yes_value_select_points"
													filterable
													placeholder="Select"
													clearable
													v-validate="
														scoringType == 'Score for each step'
															? 'required'
															: ''
													"
													name="Dependent Points"
												>
													<el-option
														v-for="(item, idx) in points_value_items"
														:key="idx"
														:label="item.title"
														:value="item.value"
													>
													</el-option>
												</el-select>
												<p>
													<span
														:v-show="errors.has(`Dependent Points`)"
														class="text-red-dark text-xs"
													>
														{{
															errors.first(`Dependent Points`)
																? "This field is required"
																: ""
														}}
													</span>
												</p>
											</el-col>
										</el-row>
										<span> </span>
									</el-card>
								</el-col>
								<el-col
									:span="dependent_inputType == 'Yes / No' ? 1 : 3"
									:offset="0"
								>
									<span
										:style="
											dependent_inputType == 'Yes / No'
												? 'margin-left: 30px'
												: 'font-size:13px; margin-left:20px'
										"
										style=""
										><b>{{
											dependent_inputType == "Yes / No" ? "No" : "Outside Range"
										}}</b></span
									>
								</el-col>
								<el-col
									style="margin-top: -25px"
									:style="
										dependent_inputType == 'Yes / No'
											? 'margin-left:20px'
											: 'margin-left:3px'
									"
									:span="dependent_inputType == 'Yes / No' ? 8 : 7"
								>
									<el-card
										style="
											border: 1px solid;
											border-color: #f9a168;
											height: 60px;
											margin-top: 20px;
										"
									>
										<el-row
											style="margin-left: -10px; margin-right: -10px"
											:gutter="0"
										>
											<el-col style="margin-top: -5px" :span="8">
												<el-select
													class="select1"
													v-model="dependent_no_value"
													filterable
													placeholder="Select Input Type"
													clearable
												>
													<el-option
														v-for="(item, idx) in yes_no_items"
														:key="idx"
														:label="item.title"
														:value="item.value"
													>
													</el-option>
												</el-select>
											</el-col>
											<el-col
												v-if="scoringType == 'Score for each step'"
												style="margin-top: 0px"
												:span="4"
												:offset="1"
											>
												<span style="margin-left: 5px">Points</span>
											</el-col>
											<el-col
												v-if="scoringType == 'Score for each step'"
												style="margin-top: -5px"
												:span="11"
											>
												<el-select
													class="select1"
													v-model="dependent_no_value_select_points"
													filterable
													placeholder="Select"
													clearable
													v-validate="
														scoringType == 'Score for each step'
															? 'required'
															: ''
													"
													name="Dependent Points"
												>
													<el-option
														v-for="(item, idx) in points_value_items"
														:key="idx"
														:label="item.title"
														:value="item.value"
													>
													</el-option>
												</el-select>
												<p>
													<span
														:v-show="errors.has(`Dependent Points`)"
														class="text-red-dark text-xs"
													>
														{{
															errors.first(`Dependent Points`)
																? "This field is required"
																: ""
														}}
													</span>
												</p>
											</el-col>
										</el-row>
									</el-card>
								</el-col>
							</el-row>
							<el-row
								v-if="
									dependent_inputType == 'Yes / No' ||
									dependent_inputType == 'Temperature' ||
									dependent_inputType == 'TPM' ||
									dependent_inputType == 'Select any one' ||
									dependent_inputType == 'Rating' ||
									dependent_inputType == 'Multiselect' ||
									dependent_inputType == 'Dropdown'
								"
								style="margin-top: 30px"
							>
								<el-col :span="5">
									<div>Critical step</div>
								</el-col>
								<el-col :span="2">
									<el-switch
										v-model="dependent_criticalStep"
										:active-text="dependent_criticalStep ? '(Yes)' : '(No)'"
										active-color="#41BE62"
									>
									</el-switch>
								</el-col>
								<el-col :span="16">
									<div
										style="
											font-size: 10px;
											margin-top: 5px;
											margin-left: 10px;
											color: #ff0000;
										"
									>
										If enabled, total points for the form will be marked as zero
										if expected response for this step is Fail
									</div>
								</el-col>
							</el-row>
							<el-row v-if="dependent_criticalStep" style="margin-top: 30px">
								<el-col :span="5">
									<div>Select any one</div>
								</el-col>
								<el-col :span="9">
									<el-select
										class="select"
										v-model="dependent_critical_option"
										filterable
										placeholder="Select"
										v-validate="'required'"
										name="Select D Critical"
										collapse-tags
									>
										<el-option
											v-for="(item, key) in critical_options"
											:key="key"
											:label="item.name"
											:value="item.id"
										>
										</el-option>
									</el-select>
									<p>
										<span
											:v-show="errors.has(`Select D Critical`)"
											class="text-red-dark text-xs"
										>
											{{
												errors.first(`Select D Critical`)
													? "This field is required"
													: ""
											}}
										</span>
									</p>
								</el-col>
							</el-row>
						</el-card>
					</div>
				</el-col>
			</el-row>
			<el-row style="margin-top: 30px">
				<el-col :span="1" :offset="18">
					<el-button
						class="button-class-white"
						style="border: none"
						@click="handleClose"
					>
						Cancel
					</el-button>
				</el-col>
				<el-col :offset="1" :span="4">
					<el-button
						:disabled="isLoading"
						@click="save_input_form()"
						class="button-class-dialog"
					>
						Update
					</el-button>
				</el-col>
			</el-row>
		</div>
	</el-dialog>
</template>

<script>
import formBuilderServices from "../../../services/formBuilderServices";
import { VueEditor } from "vue2-editor";
export default {
	name: "editFormInputDialog",
	components: {
		VueEditor,
	},
	props: {
		editformDialog: Boolean,
		storeObj: Object,
		inputTypeItems: Array,
		current_selection: String,
		scoringType: String,
		category_items: Array,
	},
	data: () => ({
		customToolbar: [
			["bold", "italic", "underline"],
			[{ list: "ordered" }, { list: "bullet" }],
			[
				{ align: "" },
				{ align: "center" },
				{ align: "right" },
				{ align: "justify" },
			],
			[{ color: [] }],
		],
		inputType: "",
		dependent_title: "",
		title: "",
		description: "",
		dependent_description: "",
		mandatoryField: false,
		dependent_mandatoryField: false,
		notApplicable: true,
		dependent_notApplicable: true,
		imageRequired: false,
		dependent_imageRequired: false,
		raiseTicket: "2",
		dependent_raiseTicket: "2",
		commentRequired: false,
		dependent_commentRequired: false,
		yes_value: "pass",
		dependent_yes_value: "pass",
		no_value: "fail",
		dependent_no_value: "fail",
		yes_no_items: [
			{ title: "Pass", value: "pass" },
			{ title: "Fail", value: "fail" },
		],
		points: "",
		dependent_points: "",
		criticalStep: false,
		dependent_criticalStep: false,
		media_url: "",
		dependent_media_url: "",
		dependentQuestions: false,
		radio: "1",
		dependent_radio: "1",
		textType: "",
		dependent_textType: "",
		textTypeItems: [
			{ title: "Short Text", value: "Short Text" },
			{ title: "Long Text", value: "Long Text" },
		],
		min_temp: null,
		dependent_min_temp: null,
		max_temp: null,
		dependent_max_temp: null,
		max_tpm: null,
		dependent_max_tpm: null,
		min_tpm: null,
		dependent_min_tpm: null,
		yes_value_select_points: "",
		dependent_yes_value_select_points: "",
		yes_value_select_points_items: [
			{ title: "1", value: "1" },
			{ title: "2", value: "2" },
		],
		no_value_select_points: "",
		dependent_no_value_select_points: "",
		radio_items: [
			{
				slno: 0,
				option: "Enter option",
				points: "Select points",
				condition_value: "Pass",
				points_value: "",
			},
			{
				slno: 1,
				option: "Enter option",
				points: "Select points",
				condition_value: "Fail",
				points_value: "",
			},
		],
		dependent_radio_items: [
			{
				slno: 0,
				option: "Enter option",
				points: "Select points",
				condition_value: "Pass",
				points_value: "",
			},
			{
				slno: 1,
				option: "Enter option",
				points: "Select points",
				condition_value: "Fail",
				points_value: "",
			},
		],
		points_value_items: [],
		number_interval: null,
		dependent_number_interval: "",
		number_interval_items: [
			{ title: "0.5", value: "0.5" },
			{ title: "1", value: "1" },
		],
		minimum_value: "",
		dependent_minimum_value: "",
		minimum_maximum_value_items: [],
		minimum_maximum_value_items_rating: [],
		dependent_minimum_maximum_value_items: [],
		maximum_value: "",
		dependent_maximum_value: "",
		exp_below_value: "",
		dependent_exp_below_value: "",
		exp_above_value: "",
		dependent_exp_above_value: "",
		dependent_inputType: "",
		filesArray: [],
		filesPreviewArray: [],
		fileURLArray: [],
		question_data: {},
		exp_yes_value: "fail",
		expectedResponse_Id1: "",
		expectedResponse_Id2: "",
		uploadedAttachments: [],
		isloading: false,
		designationItems: [],
		designation: [],
		dependent_designation: [],
		critical_options: [
			{ name: "None", id: "none" },
			{ name: "Mark Form score - 0", id: "mark_form_score_0" },
			{ name: "Mark Category score -  0", id: "mark_category_score_0" },
			{ name: "Mark Project score -  0", id: "mark_project_score_0" },
		],
		critical_option: "",
		dependent_critical_option: "",
		UploadFromGalleryRequired: false,
		timer_attempts: null,
		timer_attemptsItems: [
			{ name: 1, id: 1 },
			{ name: 2, id: 2 },
			{ name: 3, id: 3 },
			{ name: 4, id: 4 },
			{ name: 5, id: 5 },
		],
		isLoading: false,
		range: 1,
	}),
	watch: {
		dependentQuestions(val) {
			if (val) {
				this.get_min_max_item_values();
			}
		},
		editformDialog(val) {
			if (val) {
				this.list_designations();
				this.$validator.reset();
				this.title = "";
				this.description = "";
				this.mandatoryField = false;
				this.notApplicable = true;
				this.imageRequired = false;
				this.raiseTicket = "2";
				this.commentRequired = false;
				this.yes_value = "pass";
				this.no_value = "fail";
				this.points = "";
				this.criticalStep = false;
				this.media_url = "";
				this.minimum_value = "";
				this.maximum_value = "";
				this.exp_below_value = "";
				this.exp_above_value = "";
				this.number_interval = "";
				this.no_value_select_points = "";
				this.min_temp = null;
				this.max_temp = null;
				this.max_tpm = null;
				this.min_tpm = null;
				this.inputType = "";
				this.dependent_inputType = "";
				this.dependent_title = "";
				this.dependent_description = "";
				this.dependent_mandatoryField = false;
				this.dependent_notApplicable = true;
				this.dependent_imageRequired = false;
				this.dependent_raiseTicket = "2";
				this.dependent_commentRequired = false;
				this.dependent_yes_value = "pass";
				this.dependent_no_value = "fail";
				this.dependent_points = "";
				this.dependent_criticalStep = false;
				this.dependent_media_url = "";
				this.dependent_dependentQuestions = false;
				this.dependent_minimum_value = "";
				this.dependent_maximum_value = "";
				this.dependent_exp_below_value = "";
				this.dependent_exp_above_value = "";
				this.dependent_number_interval = "";
				this.dependent_no_value_select_points = "";
				this.dependent_min_temp = null;
				this.dependent_max_temp = null;
				this.dependent_max_tpm = null;
				this.dependent_min_tpm = null;
				this.critical_option = "";
				this.filesArray = [];
				this.fileURLArray = [];
				this.radio_items = [];
				this.dependent_radio_items = [];
				this.$validator.reset();
				console.log(this.storeObj, "storeObjstoreObjstoreObj");
				this.range = 1;
				if (this.scoringType == "Score for each step") {
					this.radio_items = [
						{
							slno: 0,
							option: "Enter option",
							points: "Select points",
							condition_value: "Pass",
							points_value: "",
						},
						{
							slno: 1,
							option: "Enter option",
							points: "Select points",
							condition_value: "Fail",
							points_value: "",
						},
					];
					this.dependent_radio_items = [
						{
							slno: 0,
							option: "Enter option",
							points: "Select points",
							condition_value: "Pass",
							points_value: "",
						},
						{
							slno: 1,
							option: "Enter option",
							points: "Select points",
							condition_value: "Fail",
							points_value: "",
						},
					];
				} else {
					this.radio_items = [
						{
							slno: 0,
							option: "Enter option",
							condition_value: "Pass",
							points_value: "",
						},
						{
							slno: 1,
							option: "Enter option",
							condition_value: "Fail",
							points_value: "",
						},
					];
					this.dependent_radio_items = [
						{
							slno: 0,
							option: "Enter option",
							condition_value: "Pass",
							points_value: "",
						},
						{
							slno: 1,
							option: "Enter option",
							condition_value: "Fail",
							points_value: "",
						},
					];
				}
				this.inputType = this.storeObj.type;
				this.description = this.storeObj.description;
				this.title = this.storeObj.name;
				this.timer_attempts = this.storeObj.timer_attempts;
				this.mandatoryField = this.storeObj.is_mandatory;
				this.notApplicable = this.storeObj.is_not_applicable;
				this.imageRequired = this.storeObj.is_image_required;
				this.UploadFromGalleryRequired =
					this.storeObj.media_upload_from_gallery;
				this.raiseTicket = this.storeObj.is_raise_ticket_applicable ? "1" : "2";
				if (this.storeObj.assign_action_to.length == 0) {
					this.raiseTicket = "2";
				} else {
					this.raiseTicket = "1";
				}
				this.designation = this.storeObj.assign_action_to;
				this.commentRequired = this.storeObj.is_comment_required;
				this.min_temp = this.storeObj.minimum_value;
				this.max_temp = this.storeObj.maximum_value;
				this.min_tpm = this.storeObj.minimum_value;
				this.max_tpm = this.storeObj.maximum_value;
				if (this.inputType == "Temperature") {
					if (this.max_temp == 99999999999 && this.min_temp == -99999999999) {
						this.min_temp = null;
						this.max_temp = null;
						this.range = 4;
					} else if (this.max_temp == 99999999999) {
						this.max_temp = null;
						this.title = this.title.split("( Greater")[0];
						this.range = 3;
					} else if (this.min_temp == -99999999999) {
						this.min_temp = null;
						this.title = this.title.split("( Less")[0];
						this.range = 2;
					} else {
						this.title = this.title.split("( Ideal")[0];
						this.range = 1;
					}
				}
				if (this.inputType == "TPM") {
					if (this.max_tmp == 99999999999 && this.min_tpm == -99999999999) {
						this.min_tpm = null;
						this.max_tmp = null;
						this.range = 4;
					} else if (this.max_tmp == 99999999999) {
						this.max_tmp = null;
						this.title = this.title.split("( Greater")[0];
						this.range = 3;
					} else if (this.min_tpm == -99999999999) {
						this.min_tpm = null;
						this.title = this.title.split("( Less")[0];
						this.range = 2;
					} else {
						this.title = this.title.split("( Ideal")[0];
						this.range = 1;
					}
				}
				this.get_images(this.storeObj.form_question_attachments_list);
				if (this.storeObj.expected_responses_list.length != 0) {
					this.storeObj.expected_responses_list =
						this.storeObj.expected_responses_list.sort(
							(a, b) => a.serial_no - b.serial_no
						);
					this.yes_value =
						this.storeObj.expected_responses_list[0].status_on_trigger;
					this.no_value =
						this.storeObj.expected_responses_list[1] != undefined
							? this.storeObj.expected_responses_list[1].status_on_trigger
							: "fail";
					this.yes_value_select_points =
						this.storeObj.expected_responses_list[0].points_on_trigger;
					this.no_value_select_points =
						this.storeObj.expected_responses_list[1] != undefined
							? this.storeObj.expected_responses_list[1].points_on_trigger
							: "fail";
				}
				this.number_interval = this.storeObj.number_interval.toString();
				this.minimum_value = this.storeObj.minimum_value;
				this.maximum_value = this.storeObj.maximum_value;
				this.criticalStep = this.storeObj.is_critical;
				if (this.criticalStep) {
					this.critical_option = this.storeObj.on_critical_trigger;
				}
				if (this.storeObj.input_options_list.length != 0) {
					let radio_items = [];
					for (let i = 0; i < this.storeObj.input_options_list.length; i++) {
						for (
							let j = 0;
							j < this.storeObj.expected_responses_list.length;
							j++
						) {
							if (
								this.storeObj.input_options_list[i].id ==
								this.storeObj.expected_responses_list[j].expected_input_option
							) {
								radio_items.push({
									slno: this.storeObj.input_options_list[i].serial_no,
									option: this.storeObj.input_options_list[i].name,
									option_value: this.storeObj.input_options_list[i].name,
									condition_value:
										this.storeObj.expected_responses_list[j].status_on_trigger,
									points_value: this.storeObj.input_options_list[i].value,
									id: this.storeObj.input_options_list[i].id,
								});
							}
						}
					}
					this.radio_items = radio_items;
					// for(let i =0; i<this.radio_items.length;i++){
					// 	for(let j=0;j<this.)
					// }
				}
				if (this.storeObj.dependant_question_available) {
					setTimeout(() => {
						this.dependentQuestions = true;
					}, 1000);
					this.dependent_inputType = this.storeObj.dependent_inputType;
					this.dependent_title = this.storeObj.dependent_name;
					this.dependent_min_temp =
						this.storeObj.child_form_questions_list[0].minimum_value;
					this.dependent_max_temp =
						this.storeObj.child_form_questions_list[0].maximum_value;
					this.dependent_min_tpm =
						this.storeObj.child_form_questions_list[0].minimum_value;
					this.dependent_max_tpm =
						this.storeObj.child_form_questions_list[0].maximum_value;
					this.dependent_mandatoryField =
						this.storeObj.child_form_questions_list[0].is_mandatory;
					this.dependent_notApplicable =
						this.storeObj.child_form_questions_list[0].is_not_applicable;
					this.dependent_imageRequired =
						this.storeObj.child_form_questions_list[0].is_image_required;
					this.dependent_raiseTicket = this.storeObj
						.child_form_questions_list[0].is_raise_ticket_applicable
						? "1"
						: "2";
					this.dependent_commentRequired =
						this.storeObj.child_form_questions_list[0].is_comment_required;

					if (
						this.storeObj.child_form_questions_list[0].input_options_list
							.length != 0
					) {
						let radio_items = [];
						for (
							let i = 0;
							i <
							this.storeObj.child_form_questions_list[0].input_options_list
								.length;
							i++
						) {
							radio_items.push({
								slno: this.storeObj.child_form_questions_list[0]
									.input_options_list[i].serial_no,
								option:
									this.storeObj.child_form_questions_list[0].input_options_list[
										i
									].name,
								option_value:
									this.storeObj.child_form_questions_list[0].input_options_list[
										i
									].name,
								condition_value: "Pass",
								points_value:
									this.storeObj.child_form_questions_list[0].input_options_list[
										i
									].value,
								id: this.storeObj.child_form_questions_list[0]
									.input_options_list[i].id,
							});
						}
						this.dependent_radio_items = radio_items;
					}

					if (
						this.storeObj.child_form_questions_list[0].expected_responses_list
							.length != 0
					) {
						this.dependent_yes_value =
							this.storeObj.child_form_questions_list[0].expected_responses_list[0].status_on_trigger;
						this.dependent_no_value =
							this.storeObj.child_form_questions_list[0].expected_responses_list[1].status_on_trigger;
						this.dependent_yes_value_select_points =
							this.storeObj.child_form_questions_list[0].expected_responses_list[0].points_on_trigger;
						this.dependent_no_value_select_points =
							this.storeObj.child_form_questions_list[0].expected_responses_list[1].points_on_trigger;
					}
					this.dependent_number_interval =
						this.storeObj.child_form_questions_list[0].number_interval;
					this.dependent_minimum_value =
						this.storeObj.child_form_questions_list[0].minimum_value;
					this.dependent_maximum_value =
						this.storeObj.child_form_questions_list[0].maximum_value;
					this.dependent_criticalStep =
						this.storeObj.child_form_questions_list[0].is_critical;
					if (this.dependent_criticalStep) {
						this.critical_option =
							this.storeObj.child_form_questions_list[0].on_critical_trigger;
					}
					this.radio =
						this.storeObj.always_display_questions == true ? "1" : "2";
					if (this.storeObj.expected_responses_list.length != 0) {
						let exp = "";
						let exp_below = 0;
						let exp_above = 0;
						for (
							let i = 0;
							i < this.storeObj.expected_responses_list.length;
							i++
						) {
							if (
								this.storeObj.expected_responses_list[i].id ==
								this.storeObj.child_form_questions_list[0].expected_response[0]
							) {
								exp =
									this.storeObj.expected_responses_list[i].status_on_trigger;
								if (
									this.storeObj.expected_responses_list[i].comparison_types ==
									"less_than"
								) {
									exp_below =
										this.storeObj.expected_responses_list[i]
											.expected_number_value;
								}
								if (
									this.storeObj.expected_responses_list[i].comparison_types ==
									"greater_than"
								) {
									exp_above =
										this.storeObj.expected_responses_list[i]
											.expected_number_value;
								}
							}
						}
						this.exp_yes_value = exp == "" ? "fail" : exp;
						this.exp_below_value = exp_below == 0 ? 0 : exp_below;
						this.exp_above_value = exp_above == 0 ? 0 : exp_above;
						this.get_min_max_item_values();
					}
				} else {
					this.dependentQuestions = false;
				}
				for (let i = -50; i <= 50; i++) {
					this.points_value_items.push({ title: i, value: i });
				}
			}
		},
		yes_value(val) {
			if (val == "pass") this.no_value = "fail";
			if (val == "fail") this.no_value = "pass";
		},
		no_value(val) {
			if (val == "pass") this.yes_value = "fail";
			if (val == "fail") this.yes_value = "pass";
		},
		number_interval(val) {
			if (this.inputType && this.inputType == "Rating") {
				this.minimum_maximum_value_items = [];
				let rating = null;
				let loop = val == "0.5" ? 1000 : 500;
				for (let i = 0; i <= loop; i++) {
					rating = i * Number(val);
					this.minimum_maximum_value_items.push({
						title: rating,
						value: rating,
					});
				}
				this.get_min_max_item_values();
			}
		},
		minimum_value() {
			if (this.inputType && this.inputType == "Rating")
				this.get_min_max_item_values();
		},
		maximum_value() {
			if (this.inputType && this.inputType == "Rating")
				this.get_min_max_item_values();
		},
		dependent_number_interval(val) {
			this.dependent_minimum_maximum_value_items = [];
			let rating = null;
			let loop = val == "0.5" ? 1000 : 500;
			for (let i = 0; i <= loop; i++) {
				rating = i * Number(val);
				this.dependent_minimum_maximum_value_items.push({
					title: rating,
					value: rating,
				});
			}
		},
		inputType() {
			this.dependentQuestions = false;
		},
	},
	methods: {
		validateMaxTEMP() {
			if (this.max_temp < this.min_temp) {
				this.$validator.errors.add({
					field: "Enter-Maximum-Value",
					msg: "Maximum value must be greater than the minimum value.",
					scope: "validMaxTPM",
				});
			} else {
				this.$validator.errors.clear();
			}
		},
		validateMaxTPM() {
			if (this.max_tpm < this.min_tpm) {
				this.$validator.errors.add({
					field: "Enter-Maximum-Value",
					msg: "Maximum value must be greater than the minimum value.",
					scope: "validMaxTPM",
				});
			} else {
				this.$validator.errors.clear();
			}
			this.$forceUpdate();
		},
		get_min_max_item_values() {
			let interval = [];
			let max_value = 0;
			if (this.number_interval == 1) max_value = this.maximum_value;
			else max_value = this.maximum_value * 2;
			for (let i = this.minimum_value; i <= max_value; i++) {
				interval.push({ title: i * this.number_interval });
			}
			this.minimum_maximum_value_items_rating = interval;
		},
		list_designations() {
			formBuilderServices.listAllDesignations().then((res) => {
				console.log(JSON.parse(res.data), "designat");
				this.designationItems = JSON.parse(res.data);
			});
		},
		save_input_form() {
			this.$validator.validateAll().then((result) => {
				if (result) {
					this.isLoading = true;
					let input_type = {};
					for (let i = 0; i < this.inputTypeItems.length; i++) {
						if (
							this.inputTypeItems[i].name.toLowerCase() ==
							this.inputType.toLowerCase()
						) {
							input_type = this.inputTypeItems[i];
						}
					}
					let params = {
						name: this.title,
						serial_no: this.storeObj.serial_no,
						project: null,
						form_category: this.storeObj.form_category,
						section: this.storeObj.section,
						form: this.storeObj.form,
						input_type: input_type.id,
						parent_question: "",
						expected_response: [],
						description: this.description,
						is_mandatory: this.is_mandatory,
						is_crtical: this.is_critical,
						is_image_required: this.is_image_required,
						is_comment_required: this.is_comment_required,
						is_not_applicable: this.is_not_applicable,
						is_raise_ticket_applicable: this.raiseTicket == 1 ? true : false,
						is_scoring_applicable: true,
						total_points: 0,
						dependant_question_available: this.dependentQuestions,
						always_display_questions: this.radio == "1" ? true : false,
						media_upload_from_gallery: this.UploadFromGalleryRequired,
					};
					if (this.criticalStep) {
						params.on_critical_trigger = this.critical_option;
					}
					if (this.raiseTicket == "1") {
						params.assign_action_to = this.designation;
					}
					if (this.inputType == "Temperature") {
						if (this.range == 1) {
							params.minimum_value = this.min_temp;
							params.maximum_value = this.max_temp;
							params.name = `${this.title} ( Ideal Range: ${params.minimum_value}° C to ${params.maximum_value}° C )`;
						}
						if (this.range == 2) {
							params.minimum_value = -99999999999;
							params.maximum_value = this.max_temp;
							params.name = `${this.title} ( Less than or equal to ${params.maximum_value}° C )`;
						}
						if (this.range == 3) {
							params.minimum_value = this.min_temp;
							params.maximum_value = 99999999999;
							params.name = `${this.title} ( Greater than or equal to ${params.minimum_value}° C )`;
						}
						if (this.range == 4) {
							params.minimum_value = -99999999999;
							params.maximum_value = 99999999999;
						}
					}
					if (this.inputType == "TPM") {
						if (this.range == 1) {
							params.minimum_value = this.min_tpm;
							params.maximum_value = this.max_tpm;
							params.name = `${this.title} ( Ideal Range: ${params.minimum_value}° C to ${params.maximum_value}° C )`;
						}
						if (this.range == 2) {
							params.minimum_value = -99999999999;
							params.maximum_value = this.max_tpm;
							params.name = `${this.title} ( Less than or equal to ${params.maximum_value}° C )`;
						}
						if (this.range == 3) {
							params.minimum_value = this.min_tpm;
							params.maximum_value = 99999999999;
							params.name = `${this.title} ( Greater than or equal to ${params.minimum_value}° C )`;
						}
						if (this.range == 4) {
							params.minimum_value = -99999999999;
							params.maximum_value = 99999999999;
						}
					}
					if (this.inputType == "Rating") {
						params.minimum_value = this.minimum_value;
						params.maximum_value = this.maximum_value;
						params.number_interval = this.number_interval;
					}
					if (this.inputType == "Timer") {
						params.timer_attempts = this.timer_attempts;
					}
					formBuilderServices
						.editQuestion(this.storeObj.id, params)
						.then((res) => {
							this.question_data = JSON.parse(res.data);
							console.log(this.question_data, "res patch");
							if (this.fileURLArray.length > 0) {
								this.upload_question_attachments_api();
							}
							// if (this.storeObj.type == this.inputType) {
							if (
								(this.inputType == "Yes / No" ||
									this.inputType == "Temperature" ||
									this.inputType == "TPM" ||
									(this.inputType == "Rating" && this.dependentQuestions)) &&
								this.scoringType != "Not Applicable"
							) {
								if (this.storeObj.expected_responses_list.length != 0) {
									this.expected_response_api_edit();
								} else {
									this.expected_response_api();
								}
							}
							if (this.question_data.dependant_question_available) {
								this.dependent_questions_api_edit();
							}
							if (
								this.inputType == "Select any one" ||
								this.inputType == "Multiselect" ||
								this.inputType == "Dropdown"
							) {
								this.expected_bulk_edit_api();
							}
						});
					setTimeout(() => {
						this.$notify.success({
							title: "Success",
							message: "Question Edited Successfully",
							type: "Success",
						});
						this.$validator.reset();
						this.dependentQuestions = false;
						this.$emit("clicked");
						setTimeout(() => {
							this.isLoading = false;
						}, 1000);
					}, 2000);
				} else {
					this.$notify.error({
						title: "Error",
						message: "Enter required fields",
						type: "Error",
					});
					this.isLoading = false;
					// alert("cannot upload more than 5 file");
				}
			});
		},
		expected_response_api() {
			if (this.inputType == "Rating") {
				let params = {
					question: this.question_data.id,
					form: null,
					input_boolean_value: true,
					input_number_value: 0,
					input_text_value: "",
					selected_input_option: "",
					selected_input_options: [],
					expected_boolean_value: true,
					expected_number_value:
						this.radio == "2"
							? this.exp_below_value
							: this.radio == "3"
							? this.exp_above_value
							: this.radio == "1"
							? 0
							: 0,
					expected_text_value: "",
					expected_input_option: "",
					expected_input_options: [],
					expected_range_minimum: 0,
					expected_range_maximum: 0,
					applicable_on: "question",
					comparison_types: "less_than",
					status_on_trigger: "pass",
					points_on_trigger: 0,
					serial_no: 1,
				};
				formBuilderServices.addExpectedResponse(params).then((res) => {
					console.log(res, "res exp res yes");
					this.expectedResponse_Id1 = JSON.parse(res.data).id;
					// this.$emit("clicked");
					setTimeout(() => {
						if (this.dependentQuestions) {
							this.dependent_questions_api_edit();
						}
					}, 100);
				});
			} else {
				let params = {
					question: this.question_data.id,
					form: null,
					input_boolean_value: true,
					input_number_value: 0,
					input_text_value: "",
					selected_input_option: "",
					selected_input_options: [],
					expected_boolean_value: true,
					expected_number_value: 0,
					expected_text_value: "",
					expected_input_option: "",
					expected_input_options: [],
					expected_range_minimum: 0,
					expected_range_maximum: 0,
					applicable_on: "question",
					comparison_types: "equals_to",
					status_on_trigger: this.yes_value,
					points_on_trigger:
						this.scoringType == "Score for each step"
							? this.yes_value_select_points
							: 0,
					serial_no: 1,
				};
				let params_no = {
					question: this.question_data.id,
					form: null,
					input_boolean_value: false,
					input_number_value: 0,
					input_text_value: "",
					selected_input_option: "",
					selected_input_options: [],
					expected_boolean_value: false,
					expected_number_value: 0,
					expected_text_value: "",
					expected_input_option: "",
					expected_input_options: [],
					expected_range_minimum: 0,
					expected_range_maximum: 0,
					applicable_on: "question",
					comparison_types: "equals_to",
					status_on_trigger: this.no_value,
					points_on_trigger:
						this.scoringType == "Score for each step"
							? this.no_value_select_points
							: 0,
					serial_no: 2,
				};
				for (let i = 0; i < 2; i++) {
					if (i == 0) {
						formBuilderServices.addExpectedResponse(params).then((res) => {
							console.log(res, "res exp res yes");
							this.expectedResponse_Id1 = JSON.parse(res.data).id;
							// this.$emit("clicked");
						});
					}
					if (i == 1) {
						formBuilderServices.addExpectedResponse(params_no).then((res) => {
							console.log(res, "res exp res no");
							this.expectedResponse_Id2 = JSON.parse(res.data).id;
							setTimeout(() => {
								if (this.dependentQuestions) {
									this.dependent_questions_api_edit();
								}
							}, 100);
						});
					}
				}
			}
		},
		dependent_questions_api() {
			let storeObj = {};
			for (let i = 0; i < this.inputTypeItems.length; i++) {
				if (
					this.inputTypeItems[i].name.toLowerCase() ==
					this.dependent_inputType.toLowerCase()
				) {
					storeObj = this.inputTypeItems[i];
				}
			}
			let formObject = {
				name: this.dependent_title,
				serial_no: 1,
				project: null,
				form_category: this.storeObj.formDetails.form_category,
				section:
					this.current_selection == "Section"
						? this.storeObj.selectedStepItem.id
						: null,
				form: this.storeObj.formDetails.id,
				input_type: storeObj.id,
				is_mandatory: this.dependent_mandatoryField,
				is_crtical: this.dependent_criticalStep,
				is_image_required: this.dependent_imageRequired,
				is_comment_required: this.dependent_commentRequired,
				is_not_applicable: this.dependent_notApplicable,
				is_raise_ticket_applicable:
					this.dependent_raiseTicket == "1" ? true : false,
				is_scoring_applicable: true,
				total_points: 0,
				parent_question: this.question_data.id,
			};
			if (this.dependent_criticalStep) {
				formObject.on_critical_trigger = this.dependent_critical_option;
			}
			if (this.dependent_raiseTicket == "1") {
				formObject.assign_action_to = this.dependent_designation;
			}
			if (this.dependent_inputType == "Timer") {
				formObject.timer_attempts = this.dependent_timer_attempts;
			}

			if (this.dependent_inputType == "Temperature") {
				formObject.minimum_value = this.dependent_min_temp;
				formObject.maximum_value = this.dependent_max_temp;
			}
			if (this.dependent_inputType == "TPM") {
				formObject.minimum_value = this.dependent_min_tpm;
				formObject.maximum_value = this.dependent_max_tpm;
			}
			if (this.dependent_inputType == "Rating") {
				formObject.minimum_value = this.dependent_minimum_value;
				formObject.maximum_value = this.dependent_maximum_value;
				formObject.number_interval = this.dependent_number_interval;
			}
			if (this.dependent_inputType != "Rating" && this.radio != "1") {
				formObject.expected_response =
					this.exp_yes_value == "pass"
						? new Array(this.expectedResponse_Id1)
						: new Array(this.expectedResponse_Id2);
			}
			if (this.dependent_inputType == "Rating") {
				formObject.expected_response = new Array(this.expectedResponse_Id1);
			}
			formBuilderServices.addQuestion(formObject).then((res) => {
				console.log(res, "rrrrrrrrrrrrsada dep q");
				this.question_data_dependentQuestion = JSON.parse(res.data);
				if (
					(this.dependent_inputType == "Yes / No" ||
						this.dependent_inputType == "Temperature" ||
						this.dependent_inputType == "TPM") &&
					this.scoringType != "Not Applicable"
					// this.dependent_inputType == "Rating"
				) {
					this.expected_response_api_dependentQuestion();
				}
				if (
					this.dependent_inputType == "Select any one" ||
					this.dependent_inputType == "Multiselect" ||
					this.dependent_inputType == "Dropdown"
				) {
					this.expected_bulk_add_api_dependentQuestion();
				}
				// this.$emit("clicked");
			});
		},
		expected_bulk_edit_api() {
			let params = [];
			let add_params = [];
			for (let i = 0; i < this.radio_items.length; i++) {
				if (this.radio_items[i].id) {
					params.push({
						id: this.radio_items[i].id,
						name: this.radio_items[i].option_value,
						serial_no: i + 1,
						question: this.question_data.id,
						value:
							this.radio_items[i].points_value == ""
								? 0
								: this.radio_items[i].points_value,
					});
				} else {
					add_params.push({
						name: this.radio_items[i].option_value,
						serial_no: i + 1,
						question: this.question_data.id,
						value:
							this.radio_items[i].points_value == ""
								? 0
								: this.radio_items[i].points_value,
					});
				}
			}
			console.log(params, "paramsparamsparamsparamsparamsparams");
			formBuilderServices.expectedBulkInputEdit(params).then((res) => {
				// let resp = JSON.parse(res.data);
				// console.log(resp, "resffkosf");
				// this.bulkAddExpectedResponse_api_edit(resp);
				// if (this.dependentQuestions) {
				// 	setTimeout(() => {
				// 		this.dependent_questions_api_edit();
				// 	}, 100);
				// }
			});
			if (add_params.length != 0) {
				formBuilderServices.expectedBulkInput(add_params).then((res) => {
					let resp = JSON.parse(res.data);
					this.bulkAddExpectedResponse_api(resp);
					// if (this.dependentQuestions) {
					// 	setTimeout(() => {
					// 		this.dependent_questions_api_add();
					// 	}, 100);
					// }
				});
			}
		},
		dependent_questions_api_add() {
			let storeObj = {};
			for (let i = 0; i < this.inputTypeItems.length; i++) {
				if (
					this.inputTypeItems[i].name.toLowerCase() ==
					this.dependent_inputType.toLowerCase()
				) {
					storeObj = this.inputTypeItems[i];
				}
			}
			let formObject = {
				name: this.dependent_title,
				serial_no: 1,
				project: null,
				form_category: this.storeObj.form_category,
				section: this.storeObj.section,
				form: this.storeObj.form,
				input_type: storeObj.id,
				is_mandatory: this.dependent_mandatoryField,
				is_crtical: this.dependent_criticalStep,
				is_image_required: this.dependent_imageRequired,
				is_comment_required: this.dependent_commentRequired,
				is_not_applicable: this.dependent_notApplicable,
				is_raise_ticket_applicable:
					this.dependent_raiseTicket == "1" ? true : false,
				is_scoring_applicable: true,
				total_points: 0,
				parent_question: this.question_data.id,
			};
			if (this.dependent_raiseTicket == "1") {
				formObject.assign_action_to = this.dependent_designation;
			}
			if (this.dependent_inputType == "Temperature") {
				formObject.minimum_value = this.dependent_min_temp;
				formObject.maximum_value = this.dependent_max_temp;
			}
			if (this.dependent_inputType == "TPM") {
				formObject.minimum_value = this.dependent_min_tpm;
				formObject.maximum_value = this.dependent_max_tpm;
			}
			if (this.dependent_inputType == "Rating") {
				formObject.minimum_value = this.dependent_minimum_value;
				formObject.maximum_value = this.dependent_maximum_value;
				formObject.number_interval = this.dependent_number_interval;
			}
			if (this.dependent_inputType != "Rating" && this.radio != "1") {
				formObject.expected_response =
					this.exp_yes_value == "pass"
						? new Array(this.expectedResponse_Id1)
						: new Array(this.expectedResponse_Id2);
			}
			if (this.dependent_inputType == "Rating") {
				formObject.expected_response = new Array(
					this.storeObj.expected_responses_list[0].id
				);
			}
			formBuilderServices.addQuestion(formObject).then((res) => {
				console.log(res, "rrrrrrrrrrrrsada dep q");
				this.question_data_dependentQuestion = JSON.parse(res.data);
				if (
					this.dependent_inputType == "Yes / No" ||
					this.dependent_inputType == "Temperature" ||
					this.dependent_inputType == "TPM"
					// this.dependent_inputType == "Rating"
				) {
					this.expected_response_api_dependentQuestion_add();
				}
				if (
					this.dependent_inputType == "Select any one" ||
					this.dependent_inputType == "Multiselect" ||
					this.dependent_inputType == "Dropdown"
				) {
					this.expected_bulk_add_api_dependentQuestion_add();
				}
				// this.$emit("clicked");
			});
		},
		expected_bulk_add_api_dependentQuestion_add() {
			let params = [];
			for (let i = 0; i < this.dependent_radio_items.length; i++) {
				params.push({
					name: this.dependent_radio_items[i].option_value,
					serial_no: i + 1,
					question: this.question_data_dependentQuestion.id,
					value:
						this.dependent_radio_items[i].points_value == ""
							? 0
							: this.dependent_radio_items[i].points_value,
				});
			}
			formBuilderServices.expectedBulkInput(params).then((res) => {
				console.log(res, "rrrrrrrrrrrrsada dep q");
				let resp = JSON.parse(res.data);
				this.bulkAddDependentExpectedResponse_api(resp);
			});
		},
		expected_response_api_dependentQuestion_add() {
			{
				let params = {
					question: this.question_data_dependentQuestion.id,
					form: null,
					input_boolean_value: true,
					input_number_value: 0,
					input_text_value: "",
					selected_input_option: "",
					selected_input_options: [],
					expected_boolean_value: true,
					expected_number_value: 0,
					expected_text_value: "",
					expected_input_option: "",
					expected_input_options: [],
					expected_range_minimum: 0,
					expected_range_maximum: 0,
					applicable_on: "question",
					comparison_types: "equals_to",
					status_on_trigger: this.dependent_yes_value,
					points_on_trigger:
						this.scoringType == "Score for each step"
							? this.dependent_yes_value_select_points
							: 0,
					serial_no: 1,
				};
				let params_no = {
					question: this.question_data_dependentQuestion.id,
					form: null,
					input_boolean_value: false,
					input_number_value: 0,
					input_text_value: "",
					selected_input_option: "",
					selected_input_options: [],
					expected_boolean_value: false,
					expected_number_value: 0,
					expected_text_value: "",
					expected_input_option: "",
					expected_input_options: [],
					expected_range_minimum: 0,
					expected_range_maximum: 0,
					applicable_on: "question",
					comparison_types: "equals_to",
					status_on_trigger: this.dependent_no_value,
					points_on_trigger:
						this.scoringType != "Score for each step"
							? 0
							: this.dependent_no_value_select_points,
					serial_no: 2,
				};
				for (let i = 0; i < 2; i++) {
					if (i == 0) {
						formBuilderServices.addExpectedResponse(params).then((res) => {
							console.log(res, "res dependent_es");
							// this.expectedResponse_Id1 = JSON.parse(res.data).id;
							// this.$emit("clicked");
						});
					}
					if (i == 1) {
						formBuilderServices.addExpectedResponse(params_no).then((res) => {
							console.log(res, "resdependent_ sad");
							// this.expectedResponse_Id2 = JSON.parse(res.data).id;
						});
					}
				}
			}
		},
		bulkAddExpectedResponse_api(resp) {
			let params = [];
			for (let i = 0; i < this.radio_items.length; i++) {
				for (let j = 0; j < resp.length; j++) {
					if (this.radio_items[i].option_value == resp[j].name) {
						resp[j].pass_fail =
							this.radio_items[i].condition_value == "Pass" ? "pass" : "fail";
					}
				}
			}
			for (let i = 0; i < resp.length; i++) {
				params.push({
					question: this.question_data.id,
					form: null,
					input_boolean_value: false,
					input_number_value: 0,
					input_text_value: "",
					selected_input_option: resp[i].id,
					selected_input_options: [],
					expected_boolean_value: false,
					expected_number_value: 0,
					expected_text_value: "",
					expected_input_option: resp[i].id,
					expected_input_options: [],
					expected_range_minimum: 0,
					expected_range_maximum: 0,
					applicable_on: "question",
					comparison_types: "equals_to",
					status_on_trigger: resp[i].pass_fail,
					points_on_trigger: resp[i].value,
					serial_no: resp[i].serial_no,
				});
			}
			formBuilderServices.bulkAddExpectedResponse(params).then((res) => {
				console.log(res, "responsessssssssssss");
			});
		},
		bulkAddExpectedResponse_api_edit(resp) {
			let params = [];
			for (let i = 0; i < this.radio_items.length; i++) {
				for (let j = 0; j < resp.length; j++) {
					if (this.radio_items[i].option_value == resp[j].name) {
						resp[j].pass_fail =
							this.radio_items[i].condition_value == "Pass" ? "pass" : "fail";
					}
				}
			}
			for (let i = 0; i < resp.length; i++) {
				for (let j = 0; j < this.storeObj.expected_responses_list.length; j++) {
					if (
						this.storeObj.expected_responses_list[j].expected_input_option ==
						resp[i].id
					) {
						resp[i].dep_id = this.storeObj.expected_responses_list[j].id;
					}
				}
			}
			for (let i = 0; i < resp.length; i++) {
				params.push({
					id: resp[i].dep_id,
					question: this.question_data.id,
					form: null,
					input_boolean_value: false,
					input_number_value: 0,
					input_text_value: "",
					selected_input_option: resp[i].id,
					selected_input_options: [],
					expected_boolean_value: false,
					expected_number_value: 0,
					expected_text_value: "",
					expected_input_option: resp[i].id,
					expected_input_options: [],
					expected_range_minimum: 0,
					expected_range_maximum: 0,
					applicable_on: "question",
					comparison_types: "equals_to",
					status_on_trigger: resp[i].pass_fail,
					points_on_trigger: resp[i].value,
					serial_no: resp[i].serial_no,
				});
			}
			formBuilderServices.bulkEditExpectedResponse(params).then((res) => {
				console.log(res, "responsessssssssssss");
			});
		},
		expected_response_api_edit() {
			// parent
			if (this.inputType == "Rating") {
				let params = [
					{
						id: this.storeObj.expected_responses_list[0].id,
						question: this.question_data.id,
						form: null,
						input_boolean_value: true,
						input_number_value: 0,
						input_text_value: "",
						selected_input_option: "",
						selected_input_options: [],
						expected_boolean_value: true,
						expected_number_value:
							this.radio == "2"
								? this.exp_below_value
								: this.radio == "3"
								? this.exp_above_value
								: this.radio == "1"
								? 0
								: 0,
						expected_text_value: "",
						expected_input_option: "",
						expected_input_options: [],
						expected_range_minimum: 0,
						expected_range_maximum: 0,
						applicable_on: "question",
						comparison_types: "less_than",
						status_on_trigger: "pass",
						points_on_trigger: 0,
						serial_no: 1,
					},
				];
				formBuilderServices.patchExpectedResponse(params).then((res) => {
					console.log(res, "res exp res yes");
					this.expectedResponse_Id1 = JSON.parse(res.data).id;
					setTimeout(() => {
						if (this.dependentQuestions) {
							// if (this.storeObj.dependant_question_available) {
							// 	if (
							// 		this.storeObj.dependent_inputType == this.dependent_inputType
							// 	) {
							this.dependent_questions_api_edit();
							// 	}
							// } else {
							// 	this.dependent_questions_api_add();
							// }
						}
					}, 100);
				});
			} else {
				console.log("here");
				let params = {
					id: this.storeObj.expected_responses_list[0].id,
					question: this.question_data.id,
					form: null,
					input_boolean_value: true,
					input_number_value: 0,
					input_text_value: "",
					selected_input_option: "",
					selected_input_options: [],
					expected_boolean_value: true,
					expected_number_value: 0,
					expected_text_value: "",
					expected_input_option: "",
					expected_input_options: [],
					expected_range_minimum: 0,
					expected_range_maximum: 0,
					applicable_on: "question",
					comparison_types: "equals_to",
					status_on_trigger: this.yes_value,
					points_on_trigger:
						this.scoringType != "Score for each step"
							? 0
							: this.yes_value_select_points,
					serial_no: 1,
				};
				let params_no = {
					id: this.storeObj.expected_responses_list[1].id,
					question: this.question_data.id,
					form: null,
					input_boolean_value: false,
					input_number_value: 0,
					input_text_value: "",
					selected_input_option: "",
					selected_input_options: [],
					expected_boolean_value: false,
					expected_number_value: 0,
					expected_text_value: "",
					expected_input_option: "",
					expected_input_options: [],
					expected_range_minimum: 0,
					expected_range_maximum: 0,
					applicable_on: "question",
					comparison_types: "equals_to",
					status_on_trigger: this.no_value,
					points_on_trigger:
						this.scoringType != "Score for each step"
							? 0
							: this.no_value_select_points,
					serial_no: 2,
				};
				for (let i = 0; i < 2; i++) {
					if (i == 0) {
						formBuilderServices
							.editExpectedResponse(
								this.storeObj.expected_responses_list[0].id,
								params
							)
							.then((res) => {
								console.log(res, "res exp res yes");
								this.expectedResponse_Id1 = JSON.parse(res.data).id;
							});
					}
					if (i == 1) {
						formBuilderServices
							.editExpectedResponse(
								this.storeObj.expected_responses_list[1].id,
								params_no
							)
							.then((res) => {
								console.log(res, "res exp res no");
								this.expectedResponse_Id2 = JSON.parse(res.data).id;
								setTimeout(() => {
									if (this.dependentQuestions) {
										// if (this.storeObj.dependant_question_available) {
										// 	if (
										// 		this.storeObj.dependent_inputType ==
										// 		this.dependent_inputType
										// 	) {
										this.dependent_questions_api_edit();
										// } else {
										// 	this.dependent_questions_api_add();
										// }
										// }
									}
								}, 100);
							});
					}
				}
			}
		},
		dependent_questions_api_edit() {
			let storeObj = {};
			for (let i = 0; i < this.inputTypeItems.length; i++) {
				if (
					this.inputTypeItems[i].name.toLowerCase() ==
					this.dependent_inputType.toLowerCase()
				) {
					storeObj = this.inputTypeItems[i];
				}
			}
			let formObject = {
				name: this.dependent_title,
				serial_no: 1,
				project: null,
				form_category: this.storeObj.form_category,
				section: this.storeObj.section,
				form: this.storeObj.form,
				input_type: storeObj.id,
				is_mandatory: this.dependent_mandatoryField,
				is_crtical: this.dependent_criticalStep,
				is_image_required: this.dependent_imageRequired,
				is_comment_required: this.dependent_commentRequired,
				is_not_applicable: this.dependent_notApplicable,
				is_raise_ticket_applicable:
					this.dependent_raiseTicket == "1" ? true : false,
				is_scoring_applicable: true,
				total_points: 0,
				parent_question: this.question_data.id,
			};
			if (this.dependent_criticalStep) {
				formObject.on_critical_trigger = this.dependent_critical_option;
			}
			if (this.dependent_raiseTicket == "1") {
				formObject.assign_action_to = this.dependent_designation;
			}
			if (this.dependent_inputType == "Temperature") {
				formObject.minimum_value = this.dependent_min_temp;
				formObject.maximum_value = this.dependent_max_temp;
			}
			if (this.dependent_inputType == "TPM") {
				formObject.minimum_value = this.dependent_min_tpm;
				formObject.maximum_value = this.dependent_max_tpm;
			}
			if (this.dependent_inputType == "Rating") {
				formObject.minimum_value = this.dependent_minimum_value;
				formObject.maximum_value = this.dependent_maximum_value;
				formObject.number_interval = this.dependent_number_interval;
			}
			if (this.dependent_inputType != "Rating" && this.radio != "1") {
				formObject.expected_response =
					this.exp_yes_value == "pass"
						? new Array(this.expectedResponse_Id1)
						: new Array(this.expectedResponse_Id2);
			}
			if (this.dependent_inputType == "Rating") {
				let new_val = [];
				if (
					this.storeObj.child_form_questions_list[0].expected_response[0] ==
					null
				) {
					new_val = [];
				} else {
					new_val = new Array(
						this.storeObj.child_form_questions_list[0].expected_response[0]
					);
				}
				formObject.expected_response = new_val;
			}
			formBuilderServices
				.editQuestion(
					this.storeObj.child_form_questions_list[0]
						? this.storeObj.child_form_questions_list[0].id
						: this.question_data.id,
					formObject
				)
				.then((res) => {
					this.question_data_dependentQuestion = JSON.parse(res.data);
					if (
						this.dependent_inputType == "Yes / No" ||
						this.dependent_inputType == "Temperature" ||
						this.dependent_inputType == "TPM"
					) {
						// if (
						// 	this.storeObj.child_form_questions_list[0].expected_responses_list
						// 		.length != 0
						// ) {
						this.expected_response_api_dependentQuestion_edit();
						// } else {
						// 	this.expected_response_api_dependentQuestion_add();
						// }
					}
					if (
						this.dependent_inputType == "Select any one" ||
						this.dependent_inputType == "Multiselect" ||
						this.dependent_inputType == "Dropdown"
					) {
						// if (
						// 	this.storeObj.child_form_questions_list[0].input_options_list
						// 		.length != 0
						// ) {
						this.expected_bulk_add_api_dependentQuestion_edit();
						// } else {
						// 	this.expected_bulk_add_api_dependentQuestion_add();
						// }
					}
				});
		},
		expected_response_api_dependentQuestion_edit() {
			let params = {
				question: this.question_data_dependentQuestion.id,
				form: null,
				input_boolean_value: true,
				input_number_value: 0,
				input_text_value: "",
				selected_input_option: "",
				selected_input_options: [],
				expected_boolean_value: true,
				expected_number_value: 0,
				expected_text_value: "",
				expected_input_option: "",
				expected_input_options: [],
				expected_range_minimum: 0,
				expected_range_maximum: 0,
				applicable_on: "question",
				comparison_types: "equals_to",
				status_on_trigger: this.dependent_yes_value,
				points_on_trigger:
					this.scoringType != "Score for each step"
						? 0
						: this.dependent_yes_value_select_points,
				serial_no: 1,
			};
			let params_no = {
				question: this.question_data_dependentQuestion.id,
				form: null,
				input_boolean_value: false,
				input_number_value: 0,
				input_text_value: "",
				selected_input_option: "",
				selected_input_options: [],
				expected_boolean_value: false,
				expected_number_value: 0,
				expected_text_value: "",
				expected_input_option: "",
				expected_input_options: [],
				expected_range_minimum: 0,
				expected_range_maximum: 0,
				applicable_on: "question",
				comparison_types: "equals_to",
				status_on_trigger: this.dependent_no_value,
				points_on_trigger:
					this.scoringType != "Score for each step"
						? 0
						: this.dependent_no_value_select_points,
				serial_no: 2,
			};
			for (let i = 0; i < 2; i++) {
				if (i == 0) {
					formBuilderServices
						.editExpectedResponse(
							this.storeObj.child_form_questions_list[0]
								.expected_responses_list[0].id,
							params
						)
						.then((res) => {
							console.log(res, "res dependent_es");
							// this.expectedResponse_Id1 = JSON.parse(res.data).id;
							// this.$emit("clicked");
						});
				}
				if (i == 1) {
					formBuilderServices
						.editExpectedResponse(
							this.storeObj.child_form_questions_list[0]
								.expected_responses_list[1].id,
							params_no
						)
						.then((res) => {
							console.log(res, "resdependent_ sad");
							// this.expectedResponse_Id2 = JSON.parse(res.data).id;
						});
				}
			}
		},
		expected_bulk_add_api_dependentQuestion_edit() {
			let params = [];
			let add_params = [];
			for (let i = 0; i < this.dependent_radio_items.length; i++) {
				if (this.dependent_radio_items[i].id) {
					params.push({
						id: this.dependent_radio_items[i].id,
						name: this.dependent_radio_items[i].option_value,
						serial_no: i + 1,
						question: this.question_data_dependentQuestion.id,
						value: this.dependent_radio_items[i].points_value,
					});
				} else {
					add_params.push({
						name: this.dependent_radio_items[i].option_value,
						serial_no: i + 1,
						question: this.question_data_dependentQuestion.id,
						value: this.dependent_radio_items[i].points_value,
					});
				}
			}
			console.log("add_params,", add_params);
			formBuilderServices.expectedBulkInputEdit(params).then((res) => {
				console.log(res, "rrrrrrrrrrrrsada dep q");
				let resp = JSON.parse(res.data);
				this.bulkAddDependentExpectedResponse_api_edit(resp);
			});
			if (add_params.length != 0) {
				formBuilderServices.expectedBulkInput(add_params).then((res) => {
					console.log(res, "rrrrrrrrrrrrsada dep q");
					let resp = JSON.parse(res.data);
					this.bulkAddDependentExpectedResponse_api(resp);
				});
			}
			console.log("add_params,", add_params);
		},
		bulkAddDependentExpectedResponse_api_edit(resp) {
			console.log(this.dependent_radio_items, "dependent_radio_items");
			console.log(resp, "resp qq");
			let params = [];
			for (let i = 0; i < this.dependent_radio_items.length; i++) {
				for (let j = 0; j < resp.length; j++) {
					if (this.dependent_radio_items[i].option_value == resp[j].name) {
						resp[j].pass_fail =
							this.dependent_radio_items[i].condition_value == "Pass"
								? "pass"
								: "fail";
					}
				}
			}
			for (let i = 0; i < resp.length; i++) {
				for (
					let j = 0;
					j <
					this.storeObj.child_form_questions_list[0].expected_responses_list
						.length;
					j++
				) {
					if (
						this.storeObj.child_form_questions_list[0].expected_responses_list[
							j
						].expected_input_option == resp[i].id
					) {
						resp[j].dep_id =
							this.storeObj.child_form_questions_list[0].expected_responses_list[
								j
							].id;
					}
				}
			}
			for (let i = 0; i < resp.length; i++) {
				params.push({
					id: resp[i].dep_id,
					question: this.question_data_dependentQuestion.id,
					form: null,
					input_boolean_value: false,
					input_number_value: 0,
					input_text_value: "",
					selected_input_option: resp[i].id,
					selected_input_options: [],
					expected_boolean_value: false,
					expected_number_value: 0,
					expected_text_value: "",
					expected_input_option: resp[i].id,
					expected_input_options: [],
					expected_range_minimum: 0,
					expected_range_maximum: 0,
					applicable_on: "question",
					comparison_types: "equals_to",
					status_on_trigger: resp[i].pass_fail,
					points_on_trigger: resp[i].value,
					serial_no: resp[i].serial_no,
				});
			}
			formBuilderServices.bulkEditExpectedResponse(params).then((res) => {
				console.log(res, "responsessssssssssss");
			});
		},
		bulkAddDependentExpectedResponse_api(resp) {
			let params = [];
			for (let i = 0; i < this.dependent_radio_items.length; i++) {
				for (let j = 0; j < resp.length; j++) {
					if (this.dependent_radio_items[i].option_value == resp[j].name) {
						resp[j].pass_fail =
							this.dependent_radio_items[i].condition_value == "Pass"
								? "pass"
								: "fail";
					}
				}
			}
			for (let i = 0; i < resp.length; i++) {
				params.push({
					question: this.question_data_dependentQuestion.id,
					form: null,
					input_boolean_value: false,
					input_number_value: 0,
					input_text_value: "",
					selected_input_option: resp[i].id,
					selected_input_options: [],
					expected_boolean_value: false,
					expected_number_value: 0,
					expected_text_value: "",
					expected_input_option: resp[i].id,
					expected_input_options: [],
					expected_range_minimum: 0,
					expected_range_maximum: 0,
					applicable_on: "question",
					comparison_types: "equals_to",
					status_on_trigger: resp[i].pass_fail,
					points_on_trigger: resp[i].value,
					serial_no: resp[i].serial_no,
				});
			}
			formBuilderServices.bulkAddExpectedResponse(params).then((res) => {
				console.log(res, "responsessssssssssss");
			});
		},
		get_images(arr) {
			console.log(arr, "images");
			arr.forEach(async (el) => {
				let params = {
					file_path: el.file_path,
					storage: "task",
				};
				await formBuilderServices
					.getAttachmentURL(params)
					.then((res) => {
						el.fileDetails = {
							type: el.file_name.split(".").pop(),
							file_path: el.file_path,
							src: JSON.parse(res.data).data,
							name: el.file_name,
						};
						el.src = JSON.parse(res.data).data;
					})
					.then(() => {
						this.fileURLArray = arr;
						console.log(this.fileURLArray, "sdjn");
						this.$forceUpdate();
					});
			});
		},
		handleClose() {
			this.$emit("close");
		},
		// 	displayFileList() {
		// 		const fileListDiv = document.getElementById('fileList');
		// fileListDiv.innerHTML = '';

		// this.fileURLArray.forEach(file => {
		//     const listItem = document.createElement('div');
		//     const fileType = file.type.toLowerCase();

		//     if (fileType.includes('image')) {
		//         const imgElement = document.createElement('img');
		//         imgElement.src = file.url;
		//         listItem.appendChild(imgElement);
		//     } else if (fileType === 'pdf') {
		//         const pdfEmbed = document.createElement('embed');
		//         pdfEmbed.src = file.url;
		//         pdfEmbed.type = 'application/pdf';
		//         listItem.appendChild(pdfEmbed);
		//     } else {
		//         // Handle other file types as needed
		//         listItem.textContent = `File Type: ${file.type}, URL: ${file.url}`;
		//     }

		//     fileListDiv.appendChild(listItem);
		// });
		// 	},
		getFileType(fileURL) {
			// Extract file extension from the URL
			const fileExtension = fileURL.split(".").pop();
			// You may want to map the file extension to a more user-friendly file type description
			// Customize this mapping based on your application's needs
			const fileTypeMap = {
				jpeg: "JPEG Image",
				jpg: "JPEG Image",
				png: "PNG Image",
				pdf: "PDF Document",
				gif: "GIF Image",
				csv: "CSV File",
				// Add more mappings as needed
			};
			return fileTypeMap[fileExtension.toLowerCase()] || "Unknown";
		},
		delete_file_list(item) {
			if (item.id) {
				formBuilderServices.deleteLicenseAttachments(item.id).then((res) => {
					console.log(res, "res");
				});
			}
			const indexToRemove = this.fileURLArray.findIndex(
				(file) => file.fileDetails.name === item.fileDetails.name
			);
			if (indexToRemove !== -1) {
				this.fileURLArray.splice(indexToRemove, 1);
			}
			const fileInput = this.$refs.fileUploadSelector;
			fileInput.value = null;
			this.$notify.success({
				title: "Success",
				message: "Attachment Deleted Successfully",
				type: "Success",
			});
		},
		upload_file_handler(event) {
			console.log(event.target.files, "event.target.files");
			const fileInput = document.getElementById("fileInput");
			const files = Array.from(fileInput.files);

			// Check if the number of selected files exceeds 5
			if (files.length + this.fileURLArray.length > 5) {
				this.showToast("Please select up to 5 files only.");
				return;
			}

			// Check for duplicate file names
			const existingFileNames = new Set();
			let replaceFiles = [];

			for (const file of files) {
				const fileName = file.name;

				// Check if the file size exceeds 5MB
				if (file.size > 5 * 1024 * 1024) {
					this.showToast(`Cannot upload file: ${fileName} exceeds 5MB.`);
					continue; // Skip this file
				}

				if (existingFileNames.has(fileName)) {
					replaceFiles.push(file);
				} else {
					existingFileNames.add(fileName);
				}
			}

			// Replace existing files with the latest ones
			replaceFiles.forEach((file) => {
				alert(`Replacing existing file: ${file.name}`);
			});

			// Add files to the fileURLArray
			this.fileURLArray = this.fileURLArray.concat(
				files
					.filter(
						(file) =>
							!replaceFiles.includes(file) && file.size <= 5 * 1024 * 1024
					)
					.map((file) => ({
						fileDetails: file,
						src: URL.createObjectURL(file),
					}))
			);

			console.log(this.fileURLArray, "this.fileURLArray");
		},
		showToast(message) {
			// Implement your toast logic here, for example, using a toast library or custom component
			console.log("Toast message:", message);
			// Example using a library like VueToast:
			this.$notify.error({
				title: "Error",
				message: message,
				type: "Error",
			});
		},
		add_question_attachments_api() {
			let params = [];
			for (let i = 0; i < this.uploadedAttachments.length; i++) {
				params.push({
					question: this.question_data.id,
					file_name: this.uploadedAttachments[i].file_name,
					file_path: this.uploadedAttachments[i].file_path,
				});
			}
			formBuilderServices.addQuestionAttachment(params).then((res) => {
				// let resp = JSON.parse(res.data);
				console.log(res, "resprespresp");
				// this.$emit("clicked");
			});
		},
		upload_question_attachments_api() {
			const formData = new FormData();
			const fetchAndConvertToFile = async (url) => {
				try {
					// Check if the URL is an object with src property
					if (url && typeof url === "object" && url.src) {
						const response = await fetch(url.src);
						const blob = await response.blob();

						// Extracting the filename from the URL
						const fileName = url.fileDetails.name;

						return new File([blob], fileName);
					} else {
						throw new Error("Invalid URL format");
					}
				} catch (error) {
					console.error("Error fetching or processing file:", error);
					throw error;
				}
			};
			// Create an array of promises for each URL
			const uploadPromises = this.fileURLArray
				.filter((el) => !el.id)
				.map(async (url, index) => {
					try {
						const file = await fetchAndConvertToFile(url);
						formData.append("attachments", file);
					} catch (error) {
						console.error(
							`Error at index ${index} during file processing:`,
							error
						);
					}
				});
			// Wait for all promises to resolve before proceeding
			Promise.all(uploadPromises)
				.then(() => {
					// Do something with the formData, e.g., send it to the server
					console.log(formData);
					formBuilderServices.uploadQuestionAttachment(formData).then((res) => {
						this.uploadedAttachments = JSON.parse(res.data).data;
						console.log(this.uploadedAttachments, "eeeeeeeeeeeee");
						this.add_question_attachments_api();
					});
				})
				.catch((error) => {
					console.error("Error during file processing:", error);
				});
		},
		show_excel(excel) {
			window.open(excel);
		},
		add_radio_items(type) {
			if (type == 0) {
				let radio_obj = {
					slno: this.radio_items.length,
					option: `Enter option`,
					points: "Select points",
					condition_value: "Pass",
					points_value: "",
				};
				this.radio_items.push(radio_obj);
			} else {
				let radio_obj = {
					slno: this.dependent_radio_items.length,
					option: `Enter option`,
					points: "Select points",
					condition_value: "Pass",
					points_value: "",
				};
				this.dependent_radio_items.push(radio_obj);
			}
		},
	},
};
</script>

<style></style>
